import { Paper, LinearProgress, Button, TextField, FormControl, Select, MenuItem, InputLabel, FormGroup, Typography, Dialog} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import { fetchfarerule, fetchfarequote, fetchssr, fetchbook, fetchticket, addflightData, updateflightdata } from "../api/customerapi";
import { DateCalc2, airportlist, getSumByKey2, childagearray, airlinelist} from "./date.js";
import { useState, useEffect } from "react";
import Stack from '@mui/material/Stack';
import { v4 as uuidv4 } from "uuid";
import GetRole from "./user";


const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    red: {
      color: "red",
      marginLeft: theme.spacing(3),
    },
    blue: {
      color: "blue",
      marginLeft: theme.spacing(3),
    },
    purple: {
      color: "purple",
      marginLeft: theme.spacing(3),
    },
    brown: {
      color: "brown",
      marginLeft: theme.spacing(3),
    },
    orange: {
      color: "orange",
      marginLeft: theme.spacing(3),
    },
    black: {
      color: "black",
      marginLeft: theme.spacing(3),
    },
    headertext: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginLeft: theme.spacing(3),
    },
    button2: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(10),
      height: theme.spacing(4),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    button: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: theme.spacing(14),
        height: theme.spacing(5),
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        fontSize: 10
      },
      textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(2),
        width: theme.spacing(30),
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: "left",
      },
      
  }));

const TBOBook=({result, traceid, searchData, token}) => {
  var {cuser, role}=GetRole();
    const classes = useStyles();
    const [fareruleResponse, setfareruleResponse] = useState("");
    const [farequoteResponse, setfarequoteResponse] = useState("");
    const [fareruleResponse2, setfareruleResponse2] = useState("");
    const [farequoteResponse2, setfarequoteResponse2] = useState("");
    const [ssrResponse, setssrResponse] = useState("");
    const [ssrResponse2, setssrResponse2] = useState("");
    const [bookingResponse, setbookingResponse] = useState("");
    const [bookingResponse2, setbookingResponse2] = useState("");
    const [ticketResponse, setticketResponse] = useState("");
    const [ticketResponse2, setticketResponse2] = useState("");
    const [status, setstatus] = useState("loading");
    const [showmeal, setshowmeal] = useState(false);
    const [showname, setshowname] = useState(false);
    const [namearr, setnamearr] = useState(false);
    const [baggagessr, setbaggagessr] = useState({});
    const [mealssr, setmealssr] = useState({});
    const [dialog1, setdialog1] = useState(false);
    const [dialog2, setdialog2] = useState(false);
    const [commonobj, setcommonobj] = useState({
      country:"India",
      country_code:"IN",
      cell_country_code:"+91",
      email:"debayan.ghosh@jetovacations.com",
      contact_number:"8882662454",
    });

    useEffect(() => {
      //console.log(result)
      TBOPreBook()
   
     }, []);

     var fupsomeDate = new Date();

     fupsomeDate.setDate(fupsomeDate.getDate());
     const fupy = fupsomeDate.getFullYear();
     const fupm =
       fupsomeDate.getMonth() + 1 < 10
         ? "0" + (fupsomeDate.getMonth() + 1)
         : fupsomeDate.getMonth() + 1;
     const fupdt =
       fupsomeDate.getDate() < 10
         ? "0" + fupsomeDate.getDate()
         : fupsomeDate.getDate();
     const fupfinalDate2 = fupy + "-" + fupm + "-" + fupdt;

    const handleSubmit =async (e) => {
        e.preventDefault();
        }

   

    const handleClose1 = () => {
      setdialog1(false);
   
      //window.open("/hotelview")
    };

    const handleClose2 = () => {
      setdialog2(false);
   
      //window.open("/hotelview")
    };

    const getprice=(fare)=>{
      var x=
        ("BaseFare" in fare?fare.BaseFare:0)+
        ("Tax" in fare?fare.Tax:0)+
        ("OtherCharges" in fare?fare.OtherCharges:0)+
        ("ServiceFee" in fare?fare.ServiceFee:0)+
        ("AirlineTransFee" in fare?fare.AirlineTransFee:0)-
        ("PLBEarned" in fare?fare.PLBEarned:0)-
        ("CommissionEarned" in fare?fare.CommissionEarned:0)-
        ("IncentiveEarned" in fare?fare.IncentiveEarned:0)+
        ("TdsOnPLB" in fare?fare.TdsOnPLB:0)+
        ("TdsOnCommission" in fare?fare.TdsOnCommission:0)+
        ("TdsOnIncentive" in fare?fare.TdsOnIncentive:0)+
        ("GST" in fare?fare.GST:0)
      return Math.round(x)
    }

    const getclass=(value) =>{
      if(value==2){
        return "Economy"
      }else if(value==3){
        return "Premium Economy"
      }else if (value==4){
        return "Business"
      }else if (value==5){
        return "Premium Business"
      }else if (value==6){
        return "First"
      }
    }

    const getduration=(segment)=>{
     
      var x=getSumByKey2(segment, "Duration")
      if(segment.length>1){
        for(let i=1;i<segment.length;i++){
          const temp=Math.round((new Date(segment[i].Origin.DepTime).getTime()-new Date(segment[i-1].Destination.ArrTime).getTime())/(1000*60))
          x+=temp
        }
      }
     
      return " || Total Duration: "+Math.floor(x/60)+"hrs "+Math.floor(x%60)+"mins"
    }

    const ssrcheck=async()=>{
      const finalsearchData={
        "TokenId":token,
        "TraceId":traceid,
        "ResultIndex":Array.isArray(result)?result[0].ResultIndex:result.ResultIndex,
      }
      console.log(finalsearchData)
      const serviceResponse=await fetchssr(finalsearchData)
      if(serviceResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
        console.log(serviceResponse.data)
        setssrResponse(serviceResponse.data.Response)
        if(serviceResponse.data.Response.ResponseStatus!==1){
          alert(serviceResponse.data.Response.Error.ErrorMessage)
        }
        
      }else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
      }
    }

    const ssrcheck2=async()=>{
      const finalsearchData={
        "TokenId":token,
        "TraceId":traceid,
        "ResultIndex":Array.isArray(result)?result[1].ResultIndex:result.ResultIndex,
      }
      console.log(finalsearchData)
      const serviceResponse=await fetchssr(finalsearchData)
      if(serviceResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
        console.log(serviceResponse.data)
        setssrResponse2(serviceResponse.data.Response)
        if(serviceResponse.data.Response.ResponseStatus!==1){
          alert(serviceResponse.data.Response.Error.ErrorMessage)
        }
        
      }else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
      }
    }
    
    const TBOPreBook=async()=>{
     var finalsearchData={}
     var finalsearchData2={}
      if(Array.isArray(result)){
        finalsearchData={
          "TokenId":token,
          "TraceId":traceid,
          "ResultIndex":result[0].ResultIndex,
        }
        console.log(finalsearchData)
        const ffrResponse=await fetchfarerule(finalsearchData)
        if(ffrResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            
          console.log(ffrResponse.data)
          setfareruleResponse(ffrResponse.data.Response)
      }
      else{
          alert("Something went wrong. Contact support");
          window.location = ("/home");
      }
  
      if(ffrResponse.data.Response.ResponseStatus==1){
        const ffqResponse=await fetchfarequote(finalsearchData)
        if(ffqResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            
          console.log(ffqResponse.data)
          setfarequoteResponse(ffqResponse.data.Response)
          setstatus("Normal")
          if(ffqResponse.data.Response.ResponseStatus!==1){
            alert(ffqResponse.data.Response.Error.ErrorMessage)
          }
        }else{
          alert("Something went wrong. Contact support");
          window.location = ("/home");
      }
      }else{
        alert(ffrResponse.data.Response.Error.ErrorMessage)
      }
        finalsearchData2={
          "TokenId":token,
          "TraceId":traceid,
          "ResultIndex":result[1].ResultIndex,
        }
        console.log(finalsearchData2)
        const ffrResponse2=await fetchfarerule(finalsearchData2)
        if(ffrResponse2.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            
          console.log(ffrResponse2.data.Response)
          setfareruleResponse2(ffrResponse2.data.Response)
      }
      else{
          alert("Something went wrong. Contact support");
          window.location = ("/home");
      }
  
      if(ffrResponse2.data.Response.ResponseStatus==1){
        const ffqResponse2=await fetchfarequote(finalsearchData2)
        if(ffqResponse2.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            
          console.log(ffqResponse2.data.Response)
          setfarequoteResponse2(ffqResponse2.data.Response)
          setstatus("Normal")
          if(ffqResponse2.data.Response.ResponseStatus!==1){
            alert(ffqResponse2.data.Response.Error.ErrorMessage)
          }
        }else{
          alert("Something went wrong. Contact support");
          window.location = ("/home");
      }
      }else{
        alert(ffrResponse2.data.Response.Error.ErrorMessage)
      }
      }
      else{
      const finalsearchData={
        "TokenId":token,
        "TraceId":traceid,
        "ResultIndex":result.ResultIndex,
      }
      console.log(finalsearchData)
      const ffrResponse=await fetchfarerule(finalsearchData)
      if(ffrResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          
        console.log(ffrResponse.data.Response)
        setfareruleResponse(ffrResponse.data.Response)
    }
    else{
        alert("Something went wrong. Contact support");
        window.location = ("/home");
    }

    if(ffrResponse.data.Response.ResponseStatus==1){
      const ffqResponse=await fetchfarequote(finalsearchData)
      if(ffqResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          
        console.log(ffqResponse.data.Response)
        setfarequoteResponse(ffqResponse.data.Response)
        setstatus("Normal")
        if(ffqResponse.data.Response.ResponseStatus!==1){
          alert(ffqResponse.data.Response.Error.ErrorMessage)
        }
      }else{
        alert("Something went wrong. Contact support");
        window.location = ("/home");
    }
    }else{
      alert(ffrResponse.data.Response.Error.ErrorMessage)
    }
  }

    }

    const dataentry=()=>{
      setshowname(true)
      setnamearr([])
      const temparr=[]
      if("number_adults" in searchData && searchData.number_adults>0){
        for(let i=0; i<searchData.number_adults; i++){
          const temp={
            type:"Adult",
            number:i+1,
            id:uuidv4(),
            lead_pax:"No",
            passport_country:"IN"
          }
          temparr.push(temp)
        }
      }
      if("number_child" in searchData && searchData.number_child>0){
        for(let i=0; i<searchData.number_child; i++){
          const temp={
            type:"Child",
            number:i+1,
            id:uuidv4(),
            lead_pax:"No",
            passport_country:"IN"
          }
          temparr.push(temp)
        }
      }
      if("number_infant" in searchData && searchData.number_infant>0){
      for(let i=0; i<searchData.number_infant; i++){
        const temp={
          type:"Infant",
          number:i+1,
          id:uuidv4(),
          lead_pax:"No",
          passport_country:"IN"
        }
        temparr.push(temp)
      }
    }
    setnamearr(temparr)
    }

    
    const changesalutation =(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, salutation:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changefirstname =(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, first_name:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changelastname =(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, last_name:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changegender =(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, gender:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changebirthdate =(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, birth_date:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changepassportnumber =(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, passport_number:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changepassportissue =(index, id, value)=>{
      var temp=namearr[index]
      var issue = new Date(value);
      //console.log(issue)
      var tempdate=new Date(DateCalc2(value, -1))
      //console.log(tempdate)
     const fupy = tempdate.getFullYear()+10;
     const fupm =
     tempdate.getMonth() + 1 < 10
         ? "0" + (tempdate.getMonth() + 1)
         : tempdate.getMonth() + 1;
     const fupdt =
     tempdate.getDate() < 10
         ? "0" + tempdate.getDate()
         : tempdate.getDate();
     const fupfinalDate2 = fupy + "-" + fupm + "-" + fupdt;
      //temp={...temp, passport_issue:value}
      temp={...temp, passport_issue:value, passport_expiry:fupfinalDate2}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
      //getpassportexpiry(index,id)
    }

    const changepassportexpiry =(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, passport_expiry:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const getpassportexpiry =(index, id)=>{
      var temp=namearr[index]
      //console.log(index)
      var issue = new Date(temp.passport_issue);
      var tempdate=new Date(DateCalc2(issue, -1))
      console.log(tempdate)
     const fupy = tempdate.getFullYear()+10;
     const fupm =
     tempdate.getMonth() + 1 < 10
         ? "0" + (tempdate.getMonth() + 1)
         : tempdate.getMonth() + 1;
     const fupdt =
     tempdate.getDate() < 10
         ? "0" + tempdate.getDate()
         : tempdate.getDate();
     const fupfinalDate2 = fupy + "-" + fupm + "-" + fupdt;
     temp={...temp, passport_expiry:fupfinalDate2}
     setnamearr(namearr.map(n=>n.id==id?temp:n))
      
    }

    const changepassportcountry =(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, passport_country:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changepan =(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, pan_number:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }
    
    const changebaggage =(index, id, value, segment)=>{
      var temp=namearr[index]
      var bagarr=[]
      if("baggage" in namearr[index]){
        bagarr=namearr[index].baggage
      }
      var bg=ssrResponse.Baggage[segment]
      const bg2=bg.filter(g=>g.Weight==value)
      for(let k=0;k<bg2.length;k++){
        let x=0
        for(let m=0;m<bagarr.length;m++){
          if(bg2[k].FlightNumber==bagarr[m].FlightNumber){
            if(value==""){
              bagarr[m]=null
            }else{
              bagarr[m]=bg2[k]
            }
           
            x=1
          }
        }
        if(x==0){
          bagarr.push(bg2[k])
        }
        
      }
      temp={...temp, baggage:bagarr}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changebaggage2 =(index, id, value, segment)=>{
      var temp=namearr[index]
      var bagarr=[]
      if("baggage2" in namearr[index]){
        bagarr=namearr[index].baggage2
      }
      var bg=ssrResponse2.Baggage[segment]
      const bg2=bg.filter(g=>g.Weight==value)
      for(let k=0;k<bg2.length;k++){
        let x=0
        for(let m=0;m<bagarr.length;m++){
          if(bg2[k].FlightNumber==bagarr[m].FlightNumber){
            if(value==""){
              bagarr[m]=null
            }else{
              bagarr[m]=bg2[k]
            }
            x=1
          }
        }
        if(x==0){
          bagarr.push(bg2[k])
        }
      }
      temp={...temp, baggage2:bagarr}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changemeal =(index, id, value, segment)=>{
      var temp=namearr[index]
      var mdarr=[]
      if("mealdynamic" in namearr[index]){
        mdarr=namearr[index].mealdynamic
      }
      var bg=ssrResponse.MealDynamic[segment]
      const bg2=bg.filter(g=>g.AirlineDescription==value)
      for(let k=0;k<bg2.length;k++){
        let x=0
        for(let m=0;m<mdarr.length;m++){
          if(bg2[k].FlightNumber==mdarr[m].FlightNumber){
            mdarr[m]=bg2[k]
            x=1
          }
        }
        if(x==0){
          mdarr.push(bg2[k])
        }
      }
      temp={...temp, mealdynamic:mdarr}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changemeal2 =(index, id, value, segment)=>{
      var temp=namearr[index]
      var mdarr=[]
      if("mealdynamic2" in namearr[index]){
        mdarr=namearr[index].mealdynamic2
      }
      var bg=ssrResponse2.MealDynamic[segment]
      const bg2=bg.filter(g=>g.AirlineDescription==value)
      for(let k=0;k<bg2.length;k++){
        let x=0
        for(let m=0;m<mdarr.length;m++){
          if(bg2[k].FlightNumber==mdarr[m].FlightNumber){
            mdarr[m]=bg2[k]
            x=1
          }
        }
        if(x==0){
          mdarr.push(bg2[k])
        }
      }
      temp={...temp, mealdynamic2:mdarr}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changemeals =(index, id, value)=>{
      var temp=namearr[index]
      var mdarr=[]
      if("meal" in namearr[index]){
        mdarr=namearr[index].meal
      }
     
      const bg2=ssrResponse.Meal.filter(g=>g.Description==value)
      for(let k=0;k<bg2.length;k++){
        let x=0
        for(let m=0;m<mdarr.length;m++){
          if(bg2[k].FlightNumber==mdarr[m].FlightNumber){
            mdarr[m]=bg2[k]
            x=1
          }
        }
        if(x==0){
          mdarr.push(bg2[k])
        }
      }
      temp={...temp, meal:mdarr}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changemeals2 =(index, id, value)=>{
      var temp=namearr[index]
      var mdarr=[]
      if("meal2" in namearr[index]){
        mdarr=namearr[index].meal2
      }
     
      const bg2=ssrResponse2.Meal.filter(g=>g.Description==value)
      for(let k=0;k<bg2.length;k++){
        let x=0
        for(let m=0;m<mdarr.length;m++){
          if(bg2[k].FlightNumber==mdarr[m].FlightNumber){
            mdarr[m]=bg2[k]
            x=1
          }
        }
        if(x==0){
          mdarr.push(bg2[k])
        }
      }
      temp={...temp, meal2:mdarr}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const changeleadpax=(index, id, value)=>{
      var temp=namearr[index]
      temp={...temp, lead_pax:value}
      setnamearr(namearr.map(n=>n.id==id?temp:n))
    }

    const checkbooking=()=>{
      let flag=0
      if(Array.isArray(fareruleResponse.FareRules)){
        let temp=airportlist.filter(ap=>ap.airport == fareruleResponse.FareRules[0].Origin)
        let temp2=airportlist.filter(ap=>ap.airport == fareruleResponse.FareRules[fareruleResponse.FareRules.length-1].Destination)
        if(temp[0].type=="INT" || temp2[0].type=="INT"){
          flag=1
        }
        //console.log(flag)
        return flag
      }
    }
    //console.log(searchData)
    const namecheck=(e)=>{
      e.preventDefault()
      let type=checkbooking()
      var x=0
      var y=0
      for(let i=1;i<namearr.length;i++){
        if (namearr[i].first_name && namearr[i].last_name &&namearr[i].first_name.trim()+namearr[i].last_name.trim()==namearr[i-1].first_name.trim()+namearr[i-1].last_name.trim()){
          alert("Two passengers cannot have same name")
          x=1
          break
        }
      }
      for(let i=0;i<namearr.length;i++){
        
        if(namearr[i].lead_pax=="Yes"){
          y=y+1
          //console.log(y)
        }
        if(y>1){
          alert("Only one lead pax alllowed")
          //console.log(y)
          x=1
          break
        }
        if((namearr[i].salutation=="Mr" || namearr[i].salutation=="Mstr") && namearr[i].gender!=="Male"){
          alert("Gender and salutation mismatch")
          //console.log(y)
          x=1
          break
        }
        if((namearr[i].salutation=="Mrs" || namearr[i].salutation=="Ms") && namearr[i].gender!=="Female"){
          alert("Gender and salutation mismatch")
          //console.log(y)
          x=1
          break
        }
        
        if ((namearr[i].type=="Child" && !namearr[i].birth_date)||(namearr[i].type=="Infant" && !namearr[i].birth_date)){
          alert("All child and infants must have birth dates")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsLCC && !commonobj.address){
          alert("Address is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsLCC && !commonobj.address){
          alert("Address is mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsLCC && !commonobj.email){
          alert("Email is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsLCC && !commonobj.email){
          alert("Email is mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsLCC && !commonobj.cell_country_code){
          alert("Cell country code is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsLCC && !commonobj.cell_country_code){
          alert("Cell country code is mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsLCC && !commonobj.country){
          alert("Country name is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsLCC && !commonobj.country){
          alert("Country name is mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse  && !commonobj.contact_number){
          alert("Phone number  is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2  && !commonobj.contact_number){
          alert("Phone number is mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsPANRequiredAtTicket && !namearr[i].pan_number){
          alert("PAN number is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsPANRequiredAtTicket && !namearr[i].pan_number){
          alert("PAN number is mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsPassportRequiredAtTicket && (!namearr[i].passport_number || !namearr[i].passport_country || !namearr[i].passport_expiry || !namearr[i].passport_issue)){
          alert("All passport details are mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsPassportRequiredAtTicket && (!namearr[i].passport_number || !namearr[i].passport_country || !namearr[i].passport_expiry || !namearr[i].passport_issue)){
          alert("All passport details are mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && !farequoteResponse.Results.IsLCC ){
          alert("All passport details are mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && !farequoteResponse2.Results.IsLCC ){
          alert("All passport details are mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsPassportRequiredAtTicket && new Date(namearr[i].passport_expiry).getTime()-new Date(farequoteResponse.Results.Segments[0][0].Origin.DepTime).getTime()<0){
          alert("Passport expired before travel date")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsPassportRequiredAtTicket && new Date(namearr[i].passport_expiry).getTime()-new Date(farequoteResponse.Results.Segments[0][0].Origin.DepTime).getTime()<0){
          alert("Passport expired before travel date")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsPassportRequiredAtTicket && "passport_number" in namearr[i] && namearr[i].passport_number.length!==8){
          alert("Passport number must be of 8 characters")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsPassportRequiredAtTicket && "passport_number" in namearr[i] && namearr[i].passport_number.length!==8){
          alert("Passport number must be of 8 characters")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsGSTMandatory && (!commonobj.gst_company || !commonobj.gst_number || !commonobj.gst_address || !commonobj.gst_contact || !commonobj.gst_email)){
          alert("GST details number is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsGSTMandatory && (!commonobj.gst_company || !commonobj.gst_number || !commonobj.gst_address || !commonobj.gst_contact || !commonobj.gst_email)){
          alert("GST details number is mandatory")
          x=1
          break
        }
        if(commonobj.gst_company || commonobj.gst_number || commonobj.gst_address || commonobj.gst_contact || commonobj.gst_email){
          alert("Enter all GST fields or do not fill any GST details")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.Source==50 && namearr[i].last_name.includes(" ")){
          alert("Space not allowed in last name")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.Source==50 && namearr[i].last_name.includes(" ")){
          alert("Space not allowed in last name")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.Source==19 && !namearr[i].birth_date){
          alert("Date of birth is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.Source==19 && !namearr[i].birth_date){
          alert("Date of birth is mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.AirlineCode=="AI" && type){
          alert("Passport is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.AirlineCode=="AI" && type){
          alert("Passport is mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.AirlineCode=="SG" && type){
          alert("Passport is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.AirlineCode=="SG" && type){
          alert("Passport is mandatory")
          x=1
          break
        }
        if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.AirlineCode=="FZ" && type){
          alert("Passport is mandatory")
          x=1
          break
        }
        if(farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.AirlineCode=="FZ" && type){
          alert("Passport is mandatory")
          x=1
          break
        }
        if("baggage" in namearr[i]){
          for(let j=0; j<namearr[i].baggage.length; j++){
            if(namearr[i].baggage[j].Description==2 && namearr[i].baggage[j].Weight!==0){
              alert("Baggage cannot be added to this itinerary")
              x=1
              break;
            }
          }
        }
        if("baggage2" in namearr[i]){
          for(let j=0; j<namearr[i].baggage2.length; j++){
            if(namearr[i].baggage2[j].Description==2 && namearr[i].baggage2[j].Weight!==0){
              alert("Baggage cannot be added to this itinerary")
              x=1
              break;
            }
          }
        }
      }
      if(x==0){
        //console.log(y)
        if(y==0){
          alert("Atleast one lead pax required")
        }else{
          let a=window.confirm("Are you sure you want to book?")
          if(a){
            if(farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsLCC){
              ticketflight()
            }else{
              bookflight()
            }
          }
        }
        
       
      }
      //console.log(x,y)
      //console.log(namearr)
    }

    const gettype=(value)=>{
      if(value=="Adult"){
        return 1
      }else if(value=="Child"){
        return 2
      }else if(value=="Infant"){
        return 3
      }
    }

    const getgender=(value)=>{
      if(value=="Male"){
        return 1
      }else if(value=="Female"){
        return 2
      }
    }

    const getcount=(type)=>{
      const numadt=namearr.filter(name=>name.type=="Adult")
      const numchd=namearr.filter(name=>name.type=="Child")
      const numinf=namearr.filter(name=>name.type=="Infant")
      if(type=="Child"){
        return numchd.length
      }else if(type=="Adult"){
        return numadt.length
      }else if(type=="Infant"){
        return numinf.length
      }
    }

    const bookflight=async ()=>{
      setdialog1(true)
      var passengerarr=[]
     
      const fare2=[]
        for(let i=0; i<farequoteResponse.Results.FareBreakdown.length; i++){
          const temp={
            "BaseFare":farequoteResponse.Results.FareBreakdown[i].BaseFare,
            "Tax":farequoteResponse.Results.FareBreakdown[i].Tax,
            "TransactionFee":farequoteResponse.Results.FareBreakdown[i].TransactionFee,
            "YQTax":farequoteResponse.Results.FareBreakdown[i].YQTax,
            "AdditionalTxnFeeOfrd":farequoteResponse.Results.FareBreakdown[i].AdditionalTxnFeeOfrd,
            "AdditionalTxnFeePub":farequoteResponse.Results.FareBreakdown[i].AdditionalTxnFeePub,
            "AirTransFee":farequoteResponse.Results.FareBreakdown[i].AirTransFee,
            "PassengerType":farequoteResponse.Results.FareBreakdown[i].PassengerType,
          }
          fare2.push(temp)
        }
        //console.log(fare2)
      for(let i=0; i<namearr.length; i++){
        var mealarr=[]
        const seat={

        }
        if ("meal" in namearr[i]){
          for(let j=0; j<namearr[i].meal.length;j++){
        const temp={
          "Code":namearr[i].meal[j].Code,
          "Description":namearr[i].meal[j].Description,
        }
        mealarr.push(temp);
      }
    }
        var fare={}
        for(let j=0; j<fare2.length; j++){
          if(fare2[j].PassengerType==gettype(namearr[i].type)){
            //console.log(namearr[i].PaxType)
            //fare = (({ PassengerType, ...o }) => o)(fare2[j])
            fare={
            "BaseFare":fare2[j].BaseFare/getcount(namearr[i].type),
            "Tax":fare2[j].Tax/getcount(namearr[i].type),
            "TransactionFee":fare2[j].TransactionFee/getcount(namearr[i].type)?fare2[j].TransactionFee/getcount(namearr[i].type):0,
            "YQTax":fare2[j].YQTax/getcount(namearr[i].type),
            "AdditionalTxnFeeOfrd":fare2[j].AdditionalTxnFeeOfrd/getcount(namearr[i].type),
            "AdditionalTxnFeePub":fare2[j].AdditionalTxnFeePub/getcount(namearr[i].type),
            "AirTransFee":fare2[j].AirTransFee/getcount(namearr[i].type)?fare2[j].AirTransFee/getcount(namearr[i].type):0,
            }
          }
        }

        //console.log(fare)
        const pass={
          "Title": namearr[i].salutation?namearr[i].salutation:"",
          "FirstName": namearr[i].first_name?namearr[i].first_name:"",
          "LastName": namearr[i].last_name?namearr[i].last_name:"",
          "PaxType":  namearr[i].type?gettype(namearr[i].type):"",
          "DateOfBirth":  namearr[i].birth_date,
          "Gender": namearr[i].gender?getgender(namearr[i].gender):"",
          "PAN": namearr[i].pan_number?namearr[i].pan_number:"",
          "GSTCompanyAddress":commonobj.gst_address?commonobj.gst_address:"",
          "GSTCompanyContactNumber":commonobj.gst_contact?commonobj.gst_contact:"",
          "GSTCompanyName":commonobj.gst_company?commonobj.gst_company:"",
          "GSTNumber":commonobj.gst_number?commonobj.gst_number:"",
          "GSTCompanyEmail": commonobj.gst_email?commonobj.gst_email:"",
          "PassportNo":namearr[i].passport_number?namearr[i].passport_number:"",
          "PassportExpiry":namearr[i].passport_expiry,
          "PassportIssueDate":namearr[i].passport_issue,
          "AddressLine1":commonobj.address?commonobj.address:"",
          "City":commonobj.city?commonobj.city:"",
          "CountryCode":commonobj.country_code?commonobj.country_code:"",
          "CountryName":commonobj.country?commonobj.country:"",
          "ContactNo":commonobj.contact_number?commonobj.contact_number:"",
          "Email":commonobj.email?commonobj.email:"",
          "IsLeadPax":namearr[i].lead_pax=="Yes"?true:false,
          "FFAirline":commonobj.ffairline?commonobj.ffairline:"",
          "FFNumber":commonobj.ffnumber?commonobj.ffnumber:"",
          "Nationality":namearr[i].passport_country?namearr[i].passport_country:"",
          "CellCountryCode":commonobj.cell_country_code?commonobj.cell_country_code:"",
          "Meal":"meal" in namearr[i]?mealarr[0]:null,
          //"Meal":null,
          "Fare":fare
        }
        passengerarr.push(pass)
      }

      const finalsearchData={
        "TokenId":token,
        "TraceId":traceid,
        "ResultIndex":Array.isArray(result)?result[0].ResultIndex:result.ResultIndex,
        "Passengers":passengerarr,
      }
      console.log(finalsearchData)
      const bookResponse=await fetchbook(finalsearchData)
      if(bookResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
        console.log(bookResponse.data)
        setbookingResponse(bookResponse.data.Response)
        if(bookResponse.data.Response.ResponseStatus!==1){
          alert(bookResponse.data.Response.Error.ErrorMessage)
          setdialog1(false)
        }else{
          const data={
            PNR:bookResponse.data.Response.Response.PNR,
            BookingId:bookResponse.data.Response.Response.BookingId,
            bookingdate:new Date(),
            bookedby:cuser,
            origin:"FlightItinerary" in bookResponse.data.Response.Response?bookResponse.data.Response.Response.FlightItinerary.Origin:"",
            destination:"FlightItinerary" in bookResponse.data.Response.Response?bookResponse.data.Response.Response.FlightItinerary.Destination:"",
            pax:"FlightItinerary" in bookResponse.data.Response.Response && "Passenger" in bookResponse.data.Response.Response.FlightItinerary && bookResponse.data.Response.Response.FlightItinerary.Passenger.length>0 && "FirstName" in bookResponse.data.Response.Response.FlightItinerary.Passenger[0]?bookResponse.data.Response.Response.FlightItinerary.Passenger[0].FirstName+" "+bookResponse.data.Response.Response.FlightItinerary.Passenger[0].LastName:"",
            price:"FlightItinerary" in bookResponse.data.Response.Response?getprice(bookResponse.data.Response.Response.FlightItinerary.Fare):0,
            traveldate:"FlightItinerary" in bookResponse.data.Response.Response?new Date(bookResponse.data.Response.Response.FlightItinerary.Segments[0].Origin.DepTime):null,
            ticketed:false,
            source:"FlightItinerary" in bookResponse.data.Response.Response?bookResponse.data.Response.Response.FlightItinerary.Source:"",
            bookingstatus:"Hold",
          }
          console.log(data)
          const flightaddResponse=await addflightData(data)
          if(flightaddResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            console.log(flightaddResponse.data)
            alert("Flight details saved successfully")
    
            }else{
              alert("Failed to save flight details")
            }
        }
        
      }else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
}
if(searchData.type=="Return"){
  if(farequoteResponse2 && farequoteResponse2.ResponseStatus==1){
    if(farequoteResponse2.Results.IsLCC){
      ticketflight2()
    }else{
      bookflight2()
    }
  }else{
    alert("2nd flight fare quote response failed")
  }
}


    }

    const bookflight2=async ()=>{
      var passengerarr2=[]
     
      const fare22=[]
        for(let i=0; i<farequoteResponse2.Results.FareBreakdown.length; i++){
          const temp={
            "BaseFare":farequoteResponse2.Results.FareBreakdown[i].BaseFare,
            "Tax":farequoteResponse2.Results.FareBreakdown[i].Tax,
            "TransactionFee":farequoteResponse2.Results.FareBreakdown[i].TransactionFee,
            "YQTax":farequoteResponse2.Results.FareBreakdown[i].YQTax,
            "AdditionalTxnFeeOfrd":farequoteResponse2.Results.FareBreakdown[i].AdditionalTxnFeeOfrd,
            "AdditionalTxnFeePub":farequoteResponse2.Results.FareBreakdown[i].AdditionalTxnFeePub,
            "AirTransFee":farequoteResponse2.Results.FareBreakdown[i].AirTransFee,
            "PassengerType":farequoteResponse2.Results.FareBreakdown[i].PassengerType,
          }
          fare22.push(temp)
        }
        //console.log(fare2)
      for(let i=0; i<namearr.length; i++){
        var mealarr2=[]
        const seat2={

        }
        if ("meal2" in namearr[i]){
          for(let j=0; j<namearr[i].meal2.length;j++){
        const temp={
          "Code":namearr[i].meal2[j].Code,
          "Description":namearr[i].meal2[j].Description,
        }
        mealarr2.push(temp);
      }
    }
        var fare21={}
        for(let j=0; j<fare22.length; j++){
          if(fare22[j].PassengerType==gettype(namearr[i].type)){
            //console.log(namearr[i].PaxType)
            //fare = (({ PassengerType, ...o }) => o)(fare2[j])
            fare21={
            "BaseFare":fare22[j].BaseFare/getcount(namearr[i].type),
            "Tax":fare22[j].Tax/getcount(namearr[i].type),
            "TransactionFee":fare22[j].TransactionFee/getcount(namearr[i].type)?fare22[j].TransactionFee/getcount(namearr[i].type):0,
            "YQTax":fare22[j].YQTax/getcount(namearr[i].type),
            "AdditionalTxnFeeOfrd":fare22[j].AdditionalTxnFeeOfrd/getcount(namearr[i].type),
            "AdditionalTxnFeePub":fare22[j].AdditionalTxnFeePub/getcount(namearr[i].type),
            "AirTransFee":fare22[j].AirTransFee/getcount(namearr[i].type)?fare22[j].AirTransFee/getcount(namearr[i].type):0,
            }
          }
        }

        //console.log(fare)
        const pass={
          "Title": namearr[i].salutation?namearr[i].salutation:"",
          "FirstName": namearr[i].first_name?namearr[i].first_name:"",
          "LastName": namearr[i].last_name?namearr[i].last_name:"",
          "PaxType":  namearr[i].type?gettype(namearr[i].type):"",
          "DateOfBirth":  namearr[i].birth_date,
          "Gender": namearr[i].gender?getgender(namearr[i].gender):"",
          "PAN": namearr[i].pan_number?namearr[i].pan_number:"",
          "GSTCompanyAddress":commonobj.gst_address?commonobj.gst_address:"",
          "GSTCompanyContactNumber":commonobj.gst_contact?commonobj.gst_contact:"",
          "GSTCompanyName":commonobj.gst_company?commonobj.gst_company:"",
          "GSTNumber":commonobj.gst_number?commonobj.gst_number:"",
          "GSTCompanyEmail": commonobj.gst_email?commonobj.gst_email:"",
          "PassportNo":namearr[i].passport_number?namearr[i].passport_number:"",
          "PassportExpiry":namearr[i].passport_expiry,
          "PassportIssueDate":namearr[i].passport_issue,
          "AddressLine1":commonobj.address?commonobj.address:"",
          "City":commonobj.city?commonobj.city:"",
          "CountryCode":commonobj.country_code?commonobj.country_code:"",
          "CountryName":commonobj.country?commonobj.country:"",
          "ContactNo":commonobj.contact_number?commonobj.contact_number:"",
          "Email":commonobj.email?commonobj.email:"",
          "IsLeadPax":namearr[i].lead_pax=="Yes"?true:false,
          "FFAirline":commonobj.ffairline?commonobj.ffairline:"",
          "FFNumber":commonobj.ffnumber?commonobj.ffnumber:"",
          "Nationality":namearr[i].passport_country?namearr[i].passport_country:"",
          "CellCountryCode":commonobj.cell_country_code?commonobj.cell_country_code:"",
          "Meal":"meal" in namearr[i]?mealarr2[0]:null,
          //"Meal":null,
          "Fare":fare21
        }
        passengerarr2.push(pass)
      }

      const finalsearchData={
        "TokenId":token,
        "TraceId":traceid,
        "ResultIndex":Array.isArray(result)?result[1].ResultIndex:result.ResultIndex,
        "Passengers":passengerarr2,
      }
      console.log(finalsearchData)
      const bookResponse=await fetchbook(finalsearchData)
      if(bookResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
        console.log(bookResponse.data)
        setbookingResponse2(bookResponse.data.Response)
        if(bookResponse.data.Response.ResponseStatus!==1){
          alert(bookResponse.data.Response.Error.ErrorMessage)
          setdialog1(false)
        }else{
          const data={
            PNR:bookResponse.data.Response.Response.PNR,
            BookingId:bookResponse.data.Response.Response.BookingId,
            bookingdate:new Date(),
            bookedby:cuser,
            origin:"FlightItinerary" in bookResponse.data.Response.Response?bookResponse.data.Response.Response.FlightItinerary.Origin:"",
            destination:"FlightItinerary" in bookResponse.data.Response.Response?bookResponse.data.Response.Response.FlightItinerary.Destination:"",
            pax:"FlightItinerary" in bookResponse.data.Response.Response && "Passenger" in bookResponse.data.Response.Response.FlightItinerary && bookResponse.data.Response.Response.FlightItinerary.Passenger.length>0 && "FirstName" in bookResponse.data.Response.Response.FlightItinerary.Passenger[0]?bookResponse.data.Response.Response.FlightItinerary.Passenger[0].FirstName+" "+bookResponse.data.Response.Response.FlightItinerary.Passenger[0].LastName:"",
            price:"FlightItinerary" in bookResponse.data.Response.Response?getprice(bookResponse.data.Response.Response.FlightItinerary.Fare):0,
            traveldate:"FlightItinerary" in bookResponse.data.Response.Response?new Date(bookResponse.data.Response.Response.FlightItinerary.Segments[0].Origin.DepTime):null,
            ticketed:false,
            source:"FlightItinerary" in bookResponse.data.Response.Response?bookResponse.data.Response.Response.FlightItinerary.Source:"",
            bookingstatus:"Hold",
          }
          console.log(data)
          const flightaddResponse=await addflightData(data)
          if(flightaddResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            console.log(flightaddResponse.data)
            alert("Flight details saved successfully")
    
            }else{
              alert("Failed to save flight details")
            }
        }
        
      }else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
}
    }

    const getstatus=(status)=>{
      if(status==0){
        return "Failed"
      }else if(status==1){
        return "Successful"
      }else if(status==2){
        return "NotSaved"
      }else if(status==3){
        return "NotCreated"
      }else if(status==4){
        return "NotAllowed"
      }else if(status==5){
        return "InProgress"
      }else if(status==6){
        return "TicketeAlreadyCreated"
      }else if(status==7){
        return "InProgress"
      }else if(status==8){
        return "PriceChanged"
      }else if(status==9){
        return "OtherError"
      }
    }

    const ticketnonlcc2=async()=>{
      var pax2=[]
      for(let i=0;i<bookingResponse2.Response.FlightItinerary.Passenger.length;i++){
        const temp={
          PaxId:bookingResponse2.Response.FlightItinerary.Passenger[i].PaxId?bookingResponse2.Response.FlightItinerary.Passenger[i].PaxId:0,
          PassportNo:bookingResponse2.Response.FlightItinerary.Passenger[i].PassportNo?bookingResponse2.Response.FlightItinerary.Passenger[i].PassportNo:"",
          PassportExpiry:bookingResponse2.Response.FlightItinerary.Passenger[i].PassportExpiry?bookingResponse2.Response.FlightItinerary.Passenger[i].PassportExpiry:null,
          DateOfBirth:bookingResponse2.Response.FlightItinerary.Passenger[i].DateOfBirth?bookingResponse2.Response.FlightItinerary.Passenger[i].DateOfBirth:null,
        }
        pax2.push(temp)
      }
      const finalsearchData={
        "TokenId":token,
        "TraceId":traceid,
        "PNR":bookingResponse2.Response.PNR,
        "BookingId":bookingResponse2.Response.BookingId,
        "Passport":pax2,
        "IsPriceChangeAccepted":true
      }
      console.log(finalsearchData)
      const ticketingResponse=await fetchticket(finalsearchData)
      if(ticketingResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
        console.log(ticketingResponse.data)
        setticketResponse2(ticketingResponse.data.Response)
        if(ticketingResponse.data.Response.ResponseStatus!==1){
          alert(ticketingResponse.data.Response.Error.ErrorMessage)
        }else{
        const data={
          PNR:ticketingResponse.data.Response.Response.PNR,
          BookingId:ticketingResponse.data.Response.Response.BookingId,
          bookingdate:new Date(),
          bookedby:cuser,
          origin:ticketingResponse.data.Response.Response.FlightItinerary.Origin,
          destination:ticketingResponse.data.Response.Response.FlightItinerary.Destination,
          pax:ticketingResponse.data.Response.Response.FlightItinerary.Passenger[0].FirstName+" "+ticketingResponse.data.Response.Response.FlightItinerary.Passenger[0].LastName,
          price:getprice(ticketingResponse.data.Response.Response.FlightItinerary.Fare),
          bookingstatus:getstatus(ticketingResponse.data.Response.Response.FlightItinerary.Status),
          traveldate:new Date(ticketingResponse.data.Response.Response.FlightItinerary.Segments[0].Origin.DepTime),
          ticketed:true,
        }
        console.log(data)
        const flightupdateResponse=await updateflightdata(data)
        if(flightupdateResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          console.log(flightupdateResponse.data)
          alert("FLight details saved successfully")
  
          }else{
            alert("Failed to save flight details")
          }
        }
        
      }else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
      }
    }

    const ticketnonlcc = async()=>{
      setdialog2(true)
      var pax=[]
      for(let i=0;i<bookingResponse.Response.FlightItinerary.Passenger.length;i++){
        const temp={
          PaxId:bookingResponse.Response.FlightItinerary.Passenger[i].PaxId?bookingResponse.Response.FlightItinerary.Passenger[i].PaxId:0,
          PassportNo:bookingResponse.Response.FlightItinerary.Passenger[i].PassportNo?bookingResponse.Response.FlightItinerary.Passenger[i].PassportNo:"",
          PassportExpiry:bookingResponse.Response.FlightItinerary.Passenger[i].PassportExpiry?bookingResponse.Response.FlightItinerary.Passenger[i].PassportExpiry:null,
          DateOfBirth:bookingResponse.Response.FlightItinerary.Passenger[i].DateOfBirth?bookingResponse.Response.FlightItinerary.Passenger[i].DateOfBirth:null,
        }
        pax.push(temp)
      }
      const finalsearchData={
        "TokenId":token,
        "TraceId":traceid,
        "PNR":bookingResponse.Response.PNR,
        "BookingId":bookingResponse.Response.BookingId,
        "Passport":pax,
        "IsPriceChangeAccepted":true
      }
      console.log(finalsearchData)
      const ticketingResponse=await fetchticket(finalsearchData)
      if(ticketingResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
        console.log(ticketingResponse.data)
        setticketResponse(ticketingResponse.data.Response)
        if(ticketingResponse.data.Response.ResponseStatus!==1){
          alert(ticketingResponse.data.Response.Error.ErrorMessage)
        }else{
        const data={
          PNR:ticketingResponse.data.Response.Response.PNR,
          BookingId:ticketingResponse.data.Response.Response.BookingId,
          bookingdate:new Date(),
          bookedby:cuser,
          origin:ticketingResponse.data.Response.Response.FlightItinerary.Origin,
          destination:ticketingResponse.data.Response.Response.FlightItinerary.Destination,
          pax:ticketingResponse.data.Response.Response.FlightItinerary.Passenger[0].FirstName+" "+ticketingResponse.data.Response.Response.FlightItinerary.Passenger[0].LastName,
          price:getprice(ticketingResponse.data.Response.Response.FlightItinerary.Fare),
          bookingstatus:getstatus(ticketingResponse.data.Response.Response.FlightItinerary.Status),
          traveldate:new Date(ticketingResponse.data.Response.Response.FlightItinerary.Segments[0].Origin.DepTime),
          ticketed:true,
        }
        console.log(data)
        const flightupdateResponse=await updateflightdata(data)
        if(flightupdateResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
          console.log(flightupdateResponse.data)
          alert("FLight details saved successfully")
  
          }else{
            alert("Failed to save flight details")
          }
        }
        if(bookingResponse2 && bookingResponse2.ResponseStatus==1){
          let a=window.confirm("Ticket 2nd flight?");
          if(a){
            ticketnonlcc2()
          }
        }else{
          alert("2nd flight book response not found")
        }
        
      }else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
      }
        
    }

    const selectmeal=(meal)=>{
      setmealssr(meal)
      alert("Meal Added.Proceed to enter names")
    }

    const selectbaggage=(baggage)=>{
      setbaggagessr(baggage)
      alert("Baggage Added.Proceed to enter names")
    }

    const ticketflight2=async ()=>{
      
        var passengerarr2=[]
        const fare22=[]
        for(let i=0; i<farequoteResponse2.Results.FareBreakdown.length; i++){
          const temp={
            "BaseFare":farequoteResponse2.Results.FareBreakdown[i].BaseFare,
            "Tax":farequoteResponse2.Results.FareBreakdown[i].Tax,
            "TransactionFee":farequoteResponse2.Results.FareBreakdown[i].TransactionFee,
            "YQTax":farequoteResponse2.Results.FareBreakdown[i].YQTax,
            "AdditionalTxnFeeOfrd":farequoteResponse2.Results.FareBreakdown[i].AdditionalTxnFeeOfrd,
            "AdditionalTxnFeePub":farequoteResponse2.Results.FareBreakdown[i].AdditionalTxnFeePub,
            "AirTransFee":farequoteResponse2.Results.FareBreakdown[i].AirTransFee,
            "PassengerType":farequoteResponse2.Results.FareBreakdown[i].PassengerType,
          }
          fare22.push(temp)
        }
        
      for(let i=0; i<namearr.length; i++){
        var baggage2=[]
        var mealdynamic2=[]
        if("baggage2" in namearr[i]){
          for(let j=0; j<namearr[i].baggage2.length;j++){
            
            const tempbagg={
              "WayType":namearr[i].baggage2[j].WayType,
              "Code":namearr[i].baggage2[j].Code,
              "Description":namearr[i].baggage2[j].Description,
              "Weight":namearr[i].baggage2[j].Weight,
              "Currency":namearr[i].baggage2[j].Currency,
              "Price": namearr[i].baggage2[j].Price,
              "Origin":namearr[i].baggage2[j].Origin,
              "Destination":namearr[i].baggage2[j].Destination,
            }
            baggage2.push(tempbagg)
          }
          
      }
      if("mealdynamic2" in namearr[i]){
        for(let j=0; j<namearr[i].mealdynamic2.length;j++){
          const tempmeal={
            "WayType":namearr[i].mealdynamic2[j].WayType,
            "Code":namearr[i].mealdynamic2[j].Code,
            "Description":namearr[i].mealdynamic2[j].Description,
            "AirlineDescription":namearr[i].mealdynamic2[j].AirlineDescription,
            "Currency":namearr[i].mealdynamic2[j].Currency,
            "Price":namearr[i].mealdynamic2[j].Price,
            "Origin":namearr[i].mealdynamic2[j].Origin,
            "Destination":namearr[i].mealdynamic2[j].Destination,
            "Quantity":namearr[i].mealdynamic2[j].Quantity,
            "Nationality":namearr[i].mealdynamic2[j].Nationality,
          }
          mealdynamic2.push(tempmeal)
        }
        
    }
        var fare21={}
        for(let j=0; j<fare22.length; j++){
          if(fare22[j].PassengerType==gettype(namearr[i].type)){
            //console.log(namearr[i].PaxType)
            //fare = (({ PassengerType, ...o }) => o)(fare2[j])
            fare21={
            "BaseFare":fare22[j].BaseFare/getcount(namearr[i].type),
            "Tax":fare22[j].Tax/getcount(namearr[i].type),
            "TransactionFee":fare22[j].TransactionFee/getcount(namearr[i].type)?fare22[j].TransactionFee/getcount(namearr[i].type):0,
            "YQTax":fare22[j].YQTax/getcount(namearr[i].type),
            "AdditionalTxnFeeOfrd":fare22[j].AdditionalTxnFeeOfrd/getcount(namearr[i].type),
            "AdditionalTxnFeePub":fare22[j].AdditionalTxnFeePub/getcount(namearr[i].type),
            "AirTransFee":fare22[j].AirTransFee/getcount(namearr[i].type)?fare22[j].AirTransFee/getcount(namearr[i].type):0,
            }
          }
        }

        //console.log(fare)
        const pass={
          "Title": namearr[i].salutation?namearr[i].salutation:"",
          "FirstName": namearr[i].first_name?namearr[i].first_name:"",
          "LastName": namearr[i].last_name?namearr[i].last_name:"",
          "PaxType":  namearr[i].type?gettype(namearr[i].type):"",
          "DateOfBirth":  namearr[i].birth_date,
          "Gender": namearr[i].gender?getgender(namearr[i].gender):"",
          "PAN": namearr[i].pan_number?namearr[i].pan_number:"",
          "GSTCompanyAddress":commonobj.gst_address?commonobj.gst_address:"",
          "GSTCompanyContactNumber":commonobj.gst_contact?commonobj.gst_contact:"",
          "GSTCompanyName":commonobj.gst_company?commonobj.gst_company:"",
          "GSTNumber":commonobj.gst_number?commonobj.gst_number:"",
          "GSTCompanyEmail": commonobj.gst_email?commonobj.gst_email:"",
          "PassportNo":namearr[i].passport_number?namearr[i].passport_number:"",
          "PassportExpiry":namearr[i].passport_expiry,
          "AddressLine1":commonobj.address?commonobj.address:"",
          "City":commonobj.city?commonobj.city:"",
          "CountryCode":commonobj.country_code?commonobj.country_code:"",
          "CountryName":commonobj.country?commonobj.country:"",
          "ContactNo":commonobj.contact_number?commonobj.contact_number:"",
          "Email":commonobj.email?commonobj.email:"",
          "IsLeadPax":namearr[i].lead_pax=="Yes"?true:false,
          "FFAirline":commonobj.ffairline?commonobj.ffairline:"",
          "FFNumber":commonobj.ffnumber?commonobj.ffnumber:"",
          "Nationality":namearr[i].passport_country?namearr[i].passport_country:"",
          "CellCountryCode":commonobj.cell_country_code?commonobj.cell_country_code:"",
          "IsPriceChangeAccepted":true,
          "MealDynamic":mealdynamic2.length>0?mealdynamic2:null,
          "Baggage":baggage2.length>0?baggage2:null,
          "Fare":fare21
        }
        passengerarr2.push(pass)
      }

      const finalsearchData2={
        "TokenId":token,
        "TraceId":traceid,
        "ResultIndex":result[1].ResultIndex,
        "Passengers":passengerarr2,
        "IsPriceChangeAccepted":true
      }
      console.log(finalsearchData2)
      const ticketingResponse=await fetchticket(finalsearchData2)
      if(ticketingResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
        console.log(ticketingResponse.data)
        setticketResponse2(ticketingResponse.data.Response)
        //"FlightItinerary" in ticketingResponse.data.Response.Response?console.log(ticketingResponse.data.Response.Response.FlightItinerary):console.log("ABC")
        if(ticketingResponse.data.Response.ResponseStatus!==1){
          alert(ticketingResponse.data.Response.Error.ErrorMessage)
          setdialog2(false)
        }else{
          //setticketResponse(ticketResponse.data.Response)
          const data={
            PNR:ticketingResponse.data.Response.Response.PNR,
            BookingId:ticketingResponse.data.Response.Response.BookingId,
            bookingdate:new Date(),
            bookedby:cuser,
            origin:"FlightItinerary" in ticketingResponse.data.Response.Response?ticketingResponse.data.Response.Response.FlightItinerary.Origin:"",
            destination:"FlightItinerary" in ticketingResponse.data.Response.Response?ticketingResponse.data.Response.Response.FlightItinerary.Destination:"",
            pax:"FlightItinerary" in ticketingResponse.data.Response.Response?ticketingResponse.data.Response.Response.FlightItinerary.Passenger[0].FirstName+" "+ticketingResponse.data.Response.Response.FlightItinerary.Passenger[0].LastName:"",
            price:"FlightItinerary" in ticketingResponse.data.Response.Response?getprice(ticketingResponse.data.Response.Response.FlightItinerary.Fare):0,
            traveldate:"FlightItinerary" in ticketingResponse.data.Response.Response?new Date(ticketingResponse.data.Response.Response.FlightItinerary.Segments[0].Origin.DepTime):null,
            ticketed:true,
            bookingstatus:"Successful",
          }
          //console.log(data)
          const flightaddResponse=await addflightData(data)
          if(flightaddResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            //console.log(flightaddResponse.data)
            alert("Flight details saved successfully")
    
            }else{
              alert("Failed to save flight details")
            }
        }
        
       
        
      }else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
      }
      
    }

    const ticketflight=async ()=>{
      var passengerarr=[]
     
      setdialog2(true)
      const fare2=[]
        for(let i=0; i<farequoteResponse.Results.FareBreakdown.length; i++){
          const temp={
            "BaseFare":farequoteResponse.Results.FareBreakdown[i].BaseFare,
            "Tax":farequoteResponse.Results.FareBreakdown[i].Tax,
            "TransactionFee":farequoteResponse.Results.FareBreakdown[i].TransactionFee,
            "YQTax":farequoteResponse.Results.FareBreakdown[i].YQTax,
            "AdditionalTxnFeeOfrd":farequoteResponse.Results.FareBreakdown[i].AdditionalTxnFeeOfrd,
            "AdditionalTxnFeePub":farequoteResponse.Results.FareBreakdown[i].AdditionalTxnFeePub,
            "AirTransFee":farequoteResponse.Results.FareBreakdown[i].AirTransFee,
            "PassengerType":farequoteResponse.Results.FareBreakdown[i].PassengerType,
          }
          fare2.push(temp)
        }
        
      for(let i=0; i<namearr.length; i++){
        var baggage=[]
        var mealdynamic=[]
        if("baggage" in namearr[i]){
          for(let j=0; j<namearr[i].baggage.length;j++){
            
            const tempbagg={
              "WayType":namearr[i].baggage[j].WayType,
              "Code":namearr[i].baggage[j].Code,
              "Description":namearr[i].baggage[j].Description,
              "Weight":namearr[i].baggage[j].Weight,
              "Currency":namearr[i].baggage[j].Currency,
              "Price": namearr[i].baggage[j].Price,
              "Origin":namearr[i].baggage[j].Origin,
              "Destination":namearr[i].baggage[j].Destination,
            }
            baggage.push(tempbagg)
          }
          
      }
      if("mealdynamic" in namearr[i]){
        for(let j=0; j<namearr[i].mealdynamic.length;j++){
          const tempmeal={
            "WayType":namearr[i].mealdynamic[j].WayType,
            "Code":namearr[i].mealdynamic[j].Code,
            "Description":namearr[i].mealdynamic[j].Description,
            "AirlineDescription":namearr[i].mealdynamic[j].AirlineDescription,
            "Currency":namearr[i].mealdynamic[j].Currency,
            "Price":namearr[i].mealdynamic[j].Price,
            "Origin":namearr[i].mealdynamic[j].Origin,
            "Destination":namearr[i].mealdynamic[j].Destination,
            "Quantity":namearr[i].mealdynamic[j].Quantity,
            "Nationality":namearr[i].mealdynamic[j].Nationality,
          }
          mealdynamic.push(tempmeal)
        }
        
    }
        var fare={}
        for(let j=0; j<fare2.length; j++){
          if(fare2[j].PassengerType==gettype(namearr[i].type)){
            //console.log(namearr[i].PaxType)
            //fare = (({ PassengerType, ...o }) => o)(fare2[j])
            fare={
            "BaseFare":fare2[j].BaseFare/getcount(namearr[i].type),
            "Tax":fare2[j].Tax/getcount(namearr[i].type),
            "TransactionFee":fare2[j].TransactionFee/getcount(namearr[i].type)?fare2[j].TransactionFee/getcount(namearr[i].type):0,
            "YQTax":fare2[j].YQTax/getcount(namearr[i].type),
            "AdditionalTxnFeeOfrd":fare2[j].AdditionalTxnFeeOfrd/getcount(namearr[i].type),
            "AdditionalTxnFeePub":fare2[j].AdditionalTxnFeePub/getcount(namearr[i].type),
            "AirTransFee":fare2[j].AirTransFee/getcount(namearr[i].type)?fare2[j].AirTransFee/getcount(namearr[i].type):0,
            }
          }
        }

        //console.log(fare)
        const pass={
          "Title": namearr[i].salutation?namearr[i].salutation:"",
          "FirstName": namearr[i].first_name?namearr[i].first_name:"",
          "LastName": namearr[i].last_name?namearr[i].last_name:"",
          "PaxType":  namearr[i].type?gettype(namearr[i].type):"",
          "DateOfBirth":  namearr[i].birth_date,
          "Gender": namearr[i].gender?getgender(namearr[i].gender):"",
          "PAN": namearr[i].pan_number?namearr[i].pan_number:"",
          "GSTCompanyAddress":commonobj.gst_address?commonobj.gst_address:"",
          "GSTCompanyContactNumber":commonobj.gst_contact?commonobj.gst_contact:"",
          "GSTCompanyName":commonobj.gst_company?commonobj.gst_company:"",
          "GSTNumber":commonobj.gst_number?commonobj.gst_number:"",
          "GSTCompanyEmail": commonobj.gst_email?commonobj.gst_email:"",
          "PassportNo":namearr[i].passport_number?namearr[i].passport_number:"",
          "PassportExpiry":namearr[i].passport_expiry,
          "AddressLine1":commonobj.address?commonobj.address:"",
          "City":commonobj.city?commonobj.city:"",
          "CountryCode":commonobj.country_code?commonobj.country_code:"",
          "CountryName":commonobj.country?commonobj.country:"",
          "ContactNo":commonobj.contact_number?commonobj.contact_number:"",
          "Email":commonobj.email?commonobj.email:"",
          "IsLeadPax":namearr[i].lead_pax=="Yes"?true:false,
          "FFAirline":commonobj.ffairline?commonobj.ffairline:"",
          "FFNumber":commonobj.ffnumber?commonobj.ffnumber:"",
          "Nationality":namearr[i].passport_country?namearr[i].passport_country:"",
          "CellCountryCode":commonobj.cell_country_code?commonobj.cell_country_code:"",
          "IsPriceChangeAccepted":true,
          "MealDynamic":mealdynamic.length>0?mealdynamic:null,
          "Baggage":baggage.length>0?baggage:null,
          "Fare":fare
        }
        passengerarr.push(pass)
      }

      const finalsearchData={
        "TokenId":token,
        "TraceId":traceid,
        "ResultIndex":Array.isArray(result)?result[0].ResultIndex:result.ResultIndex,
        "Passengers":passengerarr,
        "IsPriceChangeAccepted":true
      }
      console.log(finalsearchData)
      const ticketingResponse=await fetchticket(finalsearchData)
      if(ticketingResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
        console.log(ticketingResponse.data)
        setticketResponse(ticketingResponse.data.Response)
        //"FlightItinerary" in ticketingResponse.data.Response.Response?console.log(ticketingResponse.data.Response.Response.FlightItinerary):console.log("ABC")
        if(ticketingResponse.data.Response.ResponseStatus!==1){
          alert(ticketingResponse.data.Response.Error.ErrorMessage)
          setdialog2(false)
        }else{
          //setticketResponse(ticketResponse.data.Response)
          const data={
            PNR:ticketingResponse.data.Response.Response.PNR,
            BookingId:ticketingResponse.data.Response.Response.BookingId,
            bookingdate:new Date(),
            bookedby:cuser,
            origin:"FlightItinerary" in ticketingResponse.data.Response.Response?ticketingResponse.data.Response.Response.FlightItinerary.Origin:"",
            destination:"FlightItinerary" in ticketingResponse.data.Response.Response?ticketingResponse.data.Response.Response.FlightItinerary.Destination:"",
            pax:"FlightItinerary" in ticketingResponse.data.Response.Response?ticketingResponse.data.Response.Response.FlightItinerary.Passenger[0].FirstName+" "+ticketingResponse.data.Response.Response.FlightItinerary.Passenger[0].LastName:"",
            price:"FlightItinerary" in ticketingResponse.data.Response.Response?getprice(ticketingResponse.data.Response.Response.FlightItinerary.Fare):0,
            traveldate:"FlightItinerary" in ticketingResponse.data.Response.Response?new Date(ticketingResponse.data.Response.Response.FlightItinerary.Segments[0].Origin.DepTime):null,
            ticketed:true,
            bookingstatus:"Successful",
          }
          //console.log(data)
          const flightaddResponse=await addflightData(data)
          if(flightaddResponse.status == 200 || 201 || 202|| 203|| 204|| 205 || 206 || 207){
            //console.log(flightaddResponse.data)
            alert("Flight details saved successfully")
    
            }else{
              alert("Failed to save flight details")
            }
        }
        
       
        
      }else{
    alert("Something went wrong. Contact support");
    window.location = ("/home");
      }
      if(searchData.type=="Return"){
        if(farequoteResponse2 && farequoteResponse2.ResponseStatus==1 ){
          if(farequoteResponse2.Results.IsLCC){
            ticketflight2()
          }else{
            bookflight2()
          }
      }else{
        alert("2nd flight fare quote failed")
      }
      }
     
  }
    const getssrprice=(namearr)=>{
      var x=0
      for(let i=0;i<namearr.length;i++){
        if("baggage" in namearr[i]){
          for(let j=0;j<namearr[i].baggage.length;j++){
            x=x+namearr[i].baggage[j].Price
          }
        }
        if("mealdynamic" in namearr[i]){
          for(let j=0;j<namearr[i].mealdynamic.length;j++){
            x=x+namearr[i].mealdynamic[j].Price
          }
        }
        if("baggage2" in namearr[i]){
          for(let j=0;j<namearr[i].baggage2.length;j++){
            x=x+namearr[i].baggage2[j].Price
          }
        }
        if("mealdynamic2" in namearr[i]){
          for(let j=0;j<namearr[i].mealdynamic2.length;j++){
            x=x+namearr[i].mealdynamic2[j].Price
          }
        }
      }
      return x
    }

    const back2booking=() => {
      setdialog2(false)
      setdialog1(true)
    }

   //console.log(ticketResponse)
    //console.log(searchData)

    return (
      <div>
      <Dialog fullWidth maxWidth="m" open={dialog1} onClose={handleClose1}>
        {bookingResponse && "ResponseStatus" in bookingResponse?(<div>
              {bookingResponse.ResponseStatus==1?(
                <div>
                <Typography variant="h4" className={classes.red}>Booked Successfully</Typography>
                  <Typography variant="h6" className={classes.black}>Booking Id: {bookingResponse.Response.BookingId} (PNR: {bookingResponse.Response.PNR})</Typography>
                  <Typography variant="h6" className={classes.black}>{bookingResponse.Response.IsPriceChanged?"Price Changed":""} {bookingResponse.Response.IsTimeChanged?"Time Changed":""}</Typography>
                  <Typography variant="h6" className={classes.black}>{bookingResponse.Response.FlightItinerary.Origin} to {bookingResponse.Response.FlightItinerary.Destination}</Typography>
                  <Typography variant="h6" className={classes.red}>Price: INR { Math.round(
                  ("BaseFare" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.BaseFare:0)+
                  ("Tax" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.Tax:0)+
                  ("OtherCharges" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.OtherCharges:0)+
                  ("ServiceFee" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.ServiceFee:0)+
                  ("AirlineTransFee" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.AirlineTransFee:0)-
                  ("PLBEarned" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.PLBEarned:0)-
                  ("CommissionEarned" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.CommissionEarned:0)-
                  ("IncentiveEarned" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.IncentiveEarned:0)+
                  ("TdsOnPLB" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.TdsOnPLB:0)+
                  ("TdsOnCommission" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.TdsOnCommission:0)+
                  ("TdsOnIncentive" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.TdsOnIncentive:0)+
                  ("GST" in bookingResponse.Response.FlightItinerary.Fare?bookingResponse.Response.FlightItinerary.Fare.GST:0))
                  } ({bookingResponse.Response.FlightItinerary.ResultFareType})
                  </Typography>
                  {bookingResponse.Response.FlightItinerary.Segments.map(details => <div>
                    
                      <Typography variant="h6" className={classes.orange}>
                    Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} 
                  </Typography>
                  <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                  <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                  <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                  <br></br>
                
               </div>)}
               <hr></hr>
                  {bookingResponse.Response.FlightItinerary.Passenger.map(p=>
                    <Typography variant="h6" className={classes.black}>Name: {p.FirstName} {p.LastName} || Birth Date: {p.DateOfBirth?p.DateOfBirth:""} || Passport: {p.PassportNo} </Typography>
                  )}
                  <Typography variant="h6" className={classes.black}>Last Ticket Date: {bookingResponse.Response.FlightItinerary.LastTicketDate}</Typography>
                  <Typography variant="h6" className={classes.black}>{"PenaltyCharges" in bookingResponse.Response.FlightItinerary?"CancellationCharge" in bookingResponse.Response.FlightItinerary.PenaltyCharges?"Cancellation Charges: "+bookingResponse.Response.FlightItinerary.PenaltyCharges.CancellationCharge:"":""} {"PenaltyCharges" in bookingResponse.Response.FlightItinerary?"ReissueCharge" in bookingResponse.Response.FlightItinerary.PenaltyCharges?"Reissue Charges: "+bookingResponse.Response.FlightItinerary.PenaltyCharges.ReissueCharge:"":""}</Typography>
                  <Typography variant="h6" className={classes.black}>Airline Code: {bookingResponse.Response.FlightItinerary.AirlineCode} || Remark: {bookingResponse.Response.FlightItinerary.AirlineRemark}</Typography>
                
                <FormGroup row className={classes.formgroup}>
                     {role=="Admin"?(
                      <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>ticketnonlcc()}
                    
                    className={classes.button}
                  >
                    Ticket
                  </Button>
                     ):("")}
                
                  <Button
                    variant="contained"
                    color="secondary"
                    href="/flightview" 
                    
                    className={classes.button}
                  >
                    View Bookings
                  </Button>
                  </FormGroup>
                  </div>
              ):(
                <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
              )}
        </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>

    )}
    {searchData.type=="Return"?(<div>
      {bookingResponse2 && "ResponseStatus" in bookingResponse2?(<div>
              {bookingResponse2.ResponseStatus==1?(
                <div>
                <Typography variant="h4" className={classes.red}>Booked Successfully</Typography>
                  <Typography variant="h6" className={classes.black}>Booking Id: {bookingResponse2.Response.BookingId} (PNR: {bookingResponse2.Response.PNR})</Typography>
                  <Typography variant="h6" className={classes.black}>{bookingResponse2.Response.IsPriceChanged?"Price Changed":""} {bookingResponse2.Response.IsTimeChanged?"Time Changed":""}</Typography>
                  <Typography variant="h6" className={classes.black}>{bookingResponse2.Response.FlightItinerary.Origin} to {bookingResponse2.Response.FlightItinerary.Destination}</Typography>
                  <Typography variant="h6" className={classes.red}>Price: INR { Math.round(
                  ("BaseFare" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.BaseFare:0)+
                  ("Tax" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.Tax:0)+
                  ("OtherCharges" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.OtherCharges:0)+
                  ("ServiceFee" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.ServiceFee:0)+
                  ("AirlineTransFee" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.AirlineTransFee:0)-
                  ("PLBEarned" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.PLBEarned:0)-
                  ("CommissionEarned" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.CommissionEarned:0)-
                  ("IncentiveEarned" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.IncentiveEarned:0)+
                  ("TdsOnPLB" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.TdsOnPLB:0)+
                  ("TdsOnCommission" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.TdsOnCommission:0)+
                  ("TdsOnIncentive" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.TdsOnIncentive:0)+
                  ("GST" in bookingResponse2.Response.FlightItinerary.Fare?bookingResponse2.Response.FlightItinerary.Fare.GST:0))
                  } ({bookingResponse2.Response.FlightItinerary.ResultFareType})
                  </Typography>
                  {bookingResponse2.Response.FlightItinerary.Segments.map(details => <div>
                    
                      <Typography variant="h6" className={classes.orange}>
                    Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} 
                  </Typography>
                  <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                  <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                  <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                  <br></br>
                
               </div>)}
               <hr></hr>
                  {bookingResponse2.Response.FlightItinerary.Passenger.map(p=>
                    <Typography variant="h6" className={classes.black}>Name: {p.FirstName} {p.LastName} || Birth Date: {p.DateOfBirth?p.DateOfBirth:""} || Passport: {p.PassportNo} </Typography>
                  )}
                  <Typography variant="h6" className={classes.black}>Last Ticket Date: {bookingResponse2.Response.FlightItinerary.LastTicketDate}</Typography>
                  <Typography variant="h6" className={classes.black}>{"PenaltyCharges" in bookingResponse2.Response.FlightItinerary?"CancellationCharge" in bookingResponse2.Response.FlightItinerary.PenaltyCharges?"Cancellation Charges: "+bookingResponse2.Response.FlightItinerary.PenaltyCharges.CancellationCharge:"":""} {"PenaltyCharges" in bookingResponse2.Response.FlightItinerary?"ReissueCharge" in bookingResponse2.Response.FlightItinerary.PenaltyCharges?"Reissue Charges: "+bookingResponse2.Response.FlightItinerary.PenaltyCharges.ReissueCharge:"":""}</Typography>
                  <Typography variant="h6" className={classes.black}>Airline Code: {bookingResponse2.Response.FlightItinerary.AirlineCode} || Remark: {bookingResponse2.Response.FlightItinerary.AirlineRemark}</Typography>
                
                <FormGroup row className={classes.formgroup}>
                     {role=="Admin"?(
                      <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>ticketnonlcc2()}
                    
                    className={classes.button}
                  >
                    Ticket
                  </Button>
                     ):("")}
                
                  <Button
                    variant="contained"
                    color="secondary"
                    href="/flightview" 
                    
                    className={classes.button}
                  >
                    View Bookings
                  </Button>
                  </FormGroup>
                  </div>
              ):(
                <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
              )}
        </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>

    )}
    </div>):("")}
    
      </Dialog>
      <Dialog fullWidth maxWidth="m" open={dialog2} onClose={handleClose2}>
        {ticketResponse && "ResponseStatus" in ticketResponse?(<div>
              {ticketResponse.ResponseStatus==1 && "FlightItinerary" in ticketResponse.Response?(
                <div>
                <Typography variant="h4" className={classes.red}>Ticketed Successfully</Typography>
                <Typography variant="h6" className={classes.black}>Booking Id: {ticketResponse.Response.BookingId} (PNR: {ticketResponse.Response.PNR})</Typography>
                  <Typography variant="h6" className={classes.black}>{ticketResponse.Response.IsPriceChanged?"Price Changed":""} {ticketResponse.Response.IsTimeChanged?"Time Changed":""}</Typography>
                  <Typography variant="h6" className={classes.black}>{ticketResponse.Response.FlightItinerary.Origin} to {ticketResponse.Response.FlightItinerary.Destination}</Typography>
                  <Typography variant="h6" className={classes.red}>Price: INR {getprice(ticketResponse.Response.FlightItinerary.Fare)} ({ticketResponse.Response.FlightItinerary.ResultFareType})
                  </Typography>
                  {ticketResponse.Response.FlightItinerary.Segments.map(details => <div>
                    
                      <Typography variant="h6" className={classes.orange}>
                    Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} 
                  </Typography>
                  <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                  <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                  <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                  <br></br>
                
               </div>)}
               <hr></hr>
                  {ticketResponse.Response.FlightItinerary.Passenger.map(p=>
                    <Typography variant="h6" className={classes.black}>Name: {p.FirstName} {p.LastName} || Birth Date: {p.DateOfBirth?p.DateOfBirth:""} || Passport: {p.PassportNo} </Typography>
                  )}
                  <Typography variant="h6" className={classes.black}>Last Ticket Date: {ticketResponse.Response.FlightItinerary.LastTicketDate}</Typography>
                  <Typography variant="h6" className={classes.black}>{"PenaltyCharges" in ticketResponse.Response.FlightItinerary?"CancellationCharge" in ticketResponse.Response.FlightItinerary.PenaltyCharges?"Cancellation Charges: "+ticketResponse.Response.FlightItinerary.PenaltyCharges.CancellationCharge:"":""} {"PenaltyCharges" in ticketResponse.Response.FlightItinerary?"ReissueCharge" in ticketResponse.Response.FlightItinerary.PenaltyCharges?"Reissue Charges: "+ticketResponse.Response.FlightItinerary.PenaltyCharges.ReissueCharge:"":""}</Typography>
                  <Typography variant="h6" className={classes.black}>Airline Code: {ticketResponse.Response.FlightItinerary.AirlineCode} || Remark: {ticketResponse.Response.FlightItinerary.AirlineRemark}</Typography>
                
                <FormGroup row className={classes.formgroup}>
                {bookingResponse2 && bookingResponse2.ResponseStatus==1?(<Button
                    variant="contained"
                    color="secondary"
                    onClick={()=>ticketnonlcc2()}
                    
                    className={classes.button}
                  >
                    Ticket 2nd flight
                  </Button>):("")}
                  <Button
                    variant="contained"
                    color="secondary"
                    href="/flightview" 
                    
                    className={classes.button}
                  >
                    View Bookings
                  </Button>
                  {/* <Button
                    variant="contained"
                    color="secondary"
                    onClick={()=>back2booking()}
                    
                    className={classes.button}
                  >
                    Back to Booking
                  </Button> */}
                  </FormGroup>
                  </div>
              ):(
                <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
              )}
        </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>

    )}
    {searchData.type=="Return"?(<div>
      {ticketResponse2 && "ResponseStatus" in ticketResponse2?(<div>
              {ticketResponse2.ResponseStatus==1 && "FlightItinerary" in ticketResponse2.Response?(
                <div>
                <Typography variant="h4" className={classes.red}>Ticketed Successfully</Typography>
                <Typography variant="h6" className={classes.black}>Booking Id: {ticketResponse2.Response.BookingId} (PNR: {ticketResponse2.Response.PNR})</Typography>
                  <Typography variant="h6" className={classes.black}>{ticketResponse2.Response.IsPriceChanged?"Price Changed":""} {ticketResponse2.Response.IsTimeChanged?"Time Changed":""}</Typography>
                  <Typography variant="h6" className={classes.black}>{ticketResponse2.Response.FlightItinerary.Origin} to {ticketResponse2.Response.FlightItinerary.Destination}</Typography>
                  <Typography variant="h6" className={classes.red}>Price: INR {getprice(ticketResponse2.Response.FlightItinerary.Fare)} ({ticketResponse2.Response.FlightItinerary.ResultFareType})
                  </Typography>
                  {ticketResponse2.Response.FlightItinerary.Segments.map(details => <div>
                    
                      <Typography variant="h6" className={classes.orange}>
                    Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} 
                  </Typography>
                  <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - Terminal {details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                  <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                  <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                  <br></br>
                
               </div>)}
               <hr></hr>
                  {ticketResponse2.Response.FlightItinerary.Passenger.map(p=>
                    <Typography variant="h6" className={classes.black}>Name: {p.FirstName} {p.LastName} || Birth Date: {p.DateOfBirth?p.DateOfBirth:""} || Passport: {p.PassportNo} </Typography>
                  )}
                  <Typography variant="h6" className={classes.black}>Last Ticket Date: {ticketResponse2.Response.FlightItinerary.LastTicketDate}</Typography>
                  <Typography variant="h6" className={classes.black}>{"PenaltyCharges" in ticketResponse2.Response.FlightItinerary?"CancellationCharge" in ticketResponse2.Response.FlightItinerary.PenaltyCharges?"Cancellation Charges: "+ticketResponse2.Response.FlightItinerary.PenaltyCharges.CancellationCharge:"":""} {"PenaltyCharges" in ticketResponse2.Response.FlightItinerary?"ReissueCharge" in ticketResponse2.Response.FlightItinerary.PenaltyCharges?"Reissue Charges: "+ticketResponse2.Response.FlightItinerary.PenaltyCharges.ReissueCharge:"":""}</Typography>
                  <Typography variant="h6" className={classes.black}>Airline Code: {ticketResponse2.Response.FlightItinerary.AirlineCode} || Remark: {ticketResponse2.Response.FlightItinerary.AirlineRemark}</Typography>
                
                <FormGroup row className={classes.formgroup}>
                
                  <Button
                    variant="contained"
                    color="secondary"
                    href="/flightview" 
                    
                    className={classes.button}
                  >
                    View Bookings
                  </Button>
                  </FormGroup>
                  </div>
              ):(
                <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>
              )}
        </div>
        ):(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>

    )}
    </div>):("")}
    
      </Dialog>
        {status=="loading"?(
          <Stack sx={{ width: '100%', color: 'grey.500' }} spacing={2}>
      <LinearProgress color="secondary" />
      <LinearProgress color="primary" />
      <LinearProgress color="inherit" />
    </Stack>):(
      <div>
        <Paper variant="outlined" className={classes.paper}>
        <div align="center">
        <Typography variant="h4" className={classes.blue}>Flight Results</Typography>
        </div>
            {farequoteResponse && "Results" in farequoteResponse?(<div>
              <Typography variant="h6" className={classes.black}>LCC: {farequoteResponse.Results.IsLCC?"True":"False"} || GST Mandatory: {farequoteResponse.Results.IsGSTMandatory?"True":"False"} || PAN Mandatory: {farequoteResponse.Results.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {farequoteResponse.Results.IsPassportRequiredAtTicket?"True":"False"} || Is Hold Allowed With SSR:  {farequoteResponse.Results.IsHoldAllowedWithSSR?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {farequoteResponse.Results.FareBreakdown.length==1?"Adults: "+farequoteResponse.Results.FareBreakdown[0].PassengerCount:farequoteResponse.Results.FareBreakdown.length==2 && farequoteResponse.Results.FareBreakdown[1].PassengerType==2?"Adults: "+farequoteResponse.Results.FareBreakdown[0].PassengerCount+" || Child: "+farequoteResponse.Results.FareBreakdown[1].PassengerCount:farequoteResponse.Results.FareBreakdown.length==2 && farequoteResponse.Results.FareBreakdown[1].PassengerType==3?"Adults: "+farequoteResponse.Results.FareBreakdown[0].PassengerCount+" || Infant: "+farequoteResponse.Results.FareBreakdown[1].PassengerCount:farequoteResponse.Results.FareBreakdown.length==3?"Adults: "+farequoteResponse.Results.FareBreakdown[0].PassengerCount+" || Child: "+farequoteResponse.Results.FareBreakdown[1].PassengerCount+" || Infant: "+farequoteResponse.Results.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   
                  {farequoteResponse.Results.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} {getduration(segment)}
                   </Typography>
                   <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - {"Terminal "+details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                 
                </div>)}
                <Typography variant="h6" className={classes.red}>{farequoteResponse.IsPriceChanged?"Price Changed":"Old Price: INR "+ getprice(farequoteResponse.Results.Fare)} </Typography>
                <Typography variant="h6" className={classes.red}>New Price: INR { Math.round(
                  ("BaseFare" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.BaseFare:0)+
                  ("Tax" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.Tax:0)+
                  ("OtherCharges" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.OtherCharges:0)+
                  ("ServiceFee" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.ServiceFee:0)+
                  ("AirlineTransFee" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.AirlineTransFee:0)-
                  ("PLBEarned" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.PLBEarned:0)-
                  ("CommissionEarned" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.CommissionEarned:0)-
                  ("IncentiveEarned" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.IncentiveEarned:0)+
                  ("TdsOnPLB" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.TdsOnPLB:0)+
                  ("TdsOnCommission" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.TdsOnCommission:0)+
                  ("TdsOnIncentive" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.TdsOnIncentive:0)+
                  ("GST" in farequoteResponse.Results.Fare?farequoteResponse.Results.Fare.GST:0))
                  } ({farequoteResponse.Results.ResultFareType})
                  </Typography>
                <hr></hr>
                     <br></br>
                     {"MiniFareRules" in farequoteResponse.Results && farequoteResponse.Results.MiniFareRules.map(mf => <div>
                     {mf.map(rule=>
                     <Typography variant="h6" className={classes.orange}>
                     {rule.Type} for {rule.JourneyPoints} : {rule.From} to {rule.To} {rule.Units} -- {rule.Details}
                     </Typography>
                    
                     )}
                     </div>
                     )}
                     <FormGroup row className={classes.formgroup}>
                     {role=="Admin"?(
                      <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>dataentry()}
                    
                    className={classes.button}
                  >
                    Proceed
                  </Button>
                     ):("")}
                
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={()=>ssrcheck()}
                    
                    className={classes.button}
                  >
                    Show SSR
                  </Button>
                  {(ssrResponse && "Baggage" in ssrResponse) || (ssrResponse && "Meal" in ssrResponse) || (ssrResponse && "MealDynamic" in ssrResponse)?(<Button
                    variant="contained"
                    color="inherit"
                    onClick={()=>setshowmeal(!showmeal)}
                    
                    className={classes.button}
                  >
                    {showmeal?"Hide Meal":"Show Meal"}
                  </Button>):("")}
                  </FormGroup>
              </div>):("")}
              <hr></hr>
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
        {farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsLCC?(<div>
        {ssrResponse && "Baggage" in ssrResponse?(
          <div>
            {ssrResponse.Baggage.map(b=><div>
              {b.map(bg=>
              <FormGroup row>
              <Typography variant="h6" className={classes.black}>{bg.Origin} to {bg.Destination} ({bg.AirlineCode})|| {bg.Weight} kgs -- {bg.Currency} {bg.Price}</Typography>
              {/* <Button
                    variant="contained"
                    color="inherit"
                    onClick={()=>selectbaggage(bg)}
                    
                    className={classes.button2}
                  >
                   Select
                  </Button> */}
         
              </FormGroup>)}
            </div>)}
          </div>
        ):(<div>No Baggage SSR</div>)}
        {ssrResponse && "MealDynamic" in ssrResponse && showmeal?(
          <div>
            {ssrResponse.MealDynamic.map(m=><div>
              {m.map(md=>
                <FormGroup row>
              <Typography variant="h6" className={classes.black}>{md.Origin} to {md.Destination} ({md.AirlineCode}) || {md.AirlineDescription} X {md.Quantity} -- {md.Currency} {md.Price}</Typography>
              {/* <Button
                    variant="contained"
                    color="inherit"
                    onClick={()=>selectmeal(md)}
                    
                    className={classes.button2}
                  >
                   Select
                  </Button> */}
         
              </FormGroup>)}
            </div>)}
          </div>
        ):("")}
        </div>):(<div>
          {ssrResponse && "Meal" in ssrResponse && showmeal?(
          <div>
            {ssrResponse.Meal.map(m=><div>
             
              <Typography variant="h6" className={classes.black}>{m.Description}</Typography>
              <hr></hr>
            </div>)}
          </div>
        ):("")} 
        </div>)}
       
        </Paper>
        <Paper variant="outlined" className={classes.paper}>
        {farequoteResponse2 && "Results" in farequoteResponse2?(<div>
              <Typography variant="h6" className={classes.black}>LCC: {farequoteResponse2.Results.IsLCC?"True":"False"} || GST Mandatory: {farequoteResponse2.Results.IsGSTMandatory?"True":"False"} || PAN Mandatory: {farequoteResponse2.Results.IsPANRequiredAtTicket?"True":"False"}|| Passport Mandatory: {farequoteResponse2.Results.IsPassportRequiredAtTicket?"True":"False"} || Is Hold Allowed With SSR:  {farequoteResponse2.Results.IsHoldAllowedWithSSR?"True":"False"})</Typography>
                     <br></br>
                     <Typography variant="h6" className={classes.purple}>
                     {farequoteResponse2.Results.FareBreakdown.length==1?"Adults: "+farequoteResponse2.Results.FareBreakdown[0].PassengerCount:farequoteResponse2.Results.FareBreakdown.length==2 && farequoteResponse2.Results.FareBreakdown[1].PassengerType==2?"Adults: "+farequoteResponse2.Results.FareBreakdown[0].PassengerCount+" || Child: "+farequoteResponse2.Results.FareBreakdown[1].PassengerCount:farequoteResponse2.Results.FareBreakdown.length==2 && farequoteResponse2.Results.FareBreakdown[1].PassengerType==3?"Adults: "+farequoteResponse2.Results.FareBreakdown[0].PassengerCount+" || Infant: "+farequoteResponse2.Results.FareBreakdown[1].PassengerCount:farequoteResponse2.Results.FareBreakdown.length==3?"Adults: "+farequoteResponse2.Results.FareBreakdown[0].PassengerCount+" || Child: "+farequoteResponse2.Results.FareBreakdown[1].PassengerCount+" || Infant: "+farequoteResponse2.Results.FareBreakdown[2].PassengerCount:""}
                   </Typography>
                   
                  {farequoteResponse2.Results.Segments.map(segment => <div>
                    
                     {segment.map(details =><div>
                       <Typography variant="h6" className={classes.red}>
                     {"GroundTime" in details && details.GroundTime>0?("StopOver: "+Math.floor(details.GroundTime/60)+ "hrs "+ details.GroundTime%60 + "mins"):(segment[segment.indexOf(details)-1]?"StopOver: "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60*60))+" hrs "+Math.round((new Date(details.Origin.DepTime).getTime()-new Date(segment[segment.indexOf(details)-1].Destination.ArrTime).getTime())/(1000*60))%60+" mins":"")}
                   </Typography>
                   <br></br>
                       <Typography variant="h6" className={classes.orange}>
                     Airline: {details.Airline.AirlineName} ({details.Airline.AirlineCode}-{details.Airline.FlightNumber}{details.Airline.FareClass}) || Class: {getclass(details.CabinClass)} || Baggage: {details.Baggage} || CabinBaggage: {"CabinBaggage" in details?details.CabinBaggage:""} {getduration(segment)}
                   </Typography>
                   <Typography variant="h6" className={classes.blue}>Origin: {details.Origin.Airport.CityName} ({details.Origin.Airport.AirportCode}) - {"Terminal "+details.Origin.Airport.Terminal} || Departure: {new Date(details.Origin.DepTime).toLocaleString("en-IN")} </Typography> 
                   <Typography variant="h6" className={classes.blue}>Destination: {details.Destination.Airport.CityName} ({details.Destination.Airport.AirportCode}) - Terminal {details.Destination.Airport.Terminal} || Arrival: {new Date(details.Destination.ArrTime).toLocaleString("en-IN")}</Typography>
                   <Typography variant="h6" className={classes.brown}>Duration: {Math.floor(details.Duration/60)} hrs {details.Duration%60} mins || Seats Available: {details.NoOfSeatAvailable}</Typography>
                   <br></br>
                     </div>)}
                 
                </div>)}
                <Typography variant="h6" className={classes.red}>{farequoteResponse2.IsPriceChanged?"Price Changed":"Old Price: INR "+ getprice(farequoteResponse2.Results.Fare)} </Typography>
                <Typography variant="h6" className={classes.red}>New Price: INR { Math.round(
                  ("BaseFare" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.BaseFare:0)+
                  ("Tax" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.Tax:0)+
                  ("OtherCharges" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.OtherCharges:0)+
                  ("ServiceFee" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.ServiceFee:0)+
                  ("AirlineTransFee" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.AirlineTransFee:0)-
                  ("PLBEarned" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.PLBEarned:0)-
                  ("CommissionEarned" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.CommissionEarned:0)-
                  ("IncentiveEarned" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.IncentiveEarned:0)+
                  ("TdsOnPLB" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.TdsOnPLB:0)+
                  ("TdsOnCommission" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.TdsOnCommission:0)+
                  ("TdsOnIncentive" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.TdsOnIncentive:0)+
                  ("GST" in farequoteResponse2.Results.Fare?farequoteResponse2.Results.Fare.GST:0))
                  } ({farequoteResponse2.Results.ResultFareType})
                  </Typography>
                <hr></hr>
                     <br></br>
                     {farequoteResponse2.Results.MiniFareRules.map(mf => <div>
                     {mf.map(rule=>
                     <Typography variant="h6" className={classes.orange}>
                     {rule.Type} for {rule.JourneyPoints} : {rule.From} to {rule.To} {rule.Units} -- {rule.Details}
                     </Typography>
                    
                     )}
                     </div>
                     )}
                     <FormGroup row className={classes.formgroup}>
                     {role=="Admin"?(
                      <Button
                    variant="contained"
                    color="primary"
                    onClick={()=>dataentry()}
                    
                    className={classes.button}
                  >
                    Proceed
                  </Button>
                     ):("")}
                
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={()=>ssrcheck2()}
                    
                    className={classes.button}
                  >
                    Show SSR
                  </Button>
                  {(ssrResponse && "Baggage" in ssrResponse) || (ssrResponse && "Meal" in ssrResponse) || (ssrResponse && "MealDynamic" in ssrResponse)?(<Button
                    variant="contained"
                    color="inherit"
                    onClick={()=>setshowmeal(!showmeal)}
                    
                    className={classes.button}
                  >
                    {showmeal?"Hide Meal":"Show Meal"}
                  </Button>):("")}
                  </FormGroup>
              </div>):("")}
              <hr></hr>
              </Paper>
        <Paper variant="outlined" className={classes.paper}>
        {farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsLCC?(<div>
        {ssrResponse2 && "Baggage" in ssrResponse2?(
          <div>
            {ssrResponse2.Baggage.map(b=><div>
              {b.map(bg=>
              <FormGroup row>
              <Typography variant="h6" className={classes.black}>{bg.Origin} to {bg.Destination} ({bg.AirlineCode})|| {bg.Weight} kgs -- {bg.Currency} {bg.Price}</Typography>
              {/* <Button
                    variant="contained"
                    color="inherit"
                    onClick={()=>selectbaggage(bg)}
                    
                    className={classes.button2}
                  >
                   Select
                  </Button> */}
         
              </FormGroup>)}
            </div>)}
          </div>
        ):(<div>No Baggage SSR</div>)}
        {ssrResponse2 && "MealDynamic" in ssrResponse2 && showmeal?(
          <div>
            {ssrResponse2.MealDynamic.map(m=><div>
              {m.map(md=>
                <FormGroup row>
              <Typography variant="h6" className={classes.black}>{md.Origin} to {md.Destination} ({md.AirlineCode}) || {md.AirlineDescription} X {md.Quantity} -- {md.Currency} {md.Price}</Typography>
              {/* <Button
                    variant="contained"
                    color="inherit"
                    onClick={()=>selectmeal(md)}
                    
                    className={classes.button2}
                  >
                   Select
                  </Button> */}
         
              </FormGroup>)}
            </div>)}
          </div>
        ):("")}
        </div>):(<div>
          {ssrResponse2 && "Meal" in ssrResponse2 && showmeal?(
          <div>
            {ssrResponse2.Meal.map(m=><div>
             
              <Typography variant="h6" className={classes.black}>{m.Description}</Typography>
              <hr></hr>
            </div>)}
          </div>
        ):("")} 
        </div>)}
       
        </Paper>

        
        {showname?(<div>
          <Paper variant="outlined" className={classes.paper}>
          <form onSubmit={namecheck}>
          {namearr.length>0 && namearr.map(name=>
          <div>
          
            <Typography variant="h6" className={classes.black}>{name.type} {name.number}</Typography>
            <FormGroup row className={classes.formGroup}>
            <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="salutation">Salutation</InputLabel>
                    <Select
                      required
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="salutation"
                      variant="outlined"
                      value={name.salutation}
                      onChange={(e) =>
                        changesalutation(namearr.indexOf(name), name.id, e.target.value)
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                     
                      <MenuItem value={"Mr"}>Mr</MenuItem>
                      <MenuItem value={"Mrs"}>Mrs</MenuItem>
                      <MenuItem value={"Ms"}>Ms</MenuItem>
                      <MenuItem value={"Mstr"}>Mstr</MenuItem>
                    </Select>
                  </FormControl>
                  <TextField
                    variant="outlined"
                    label={"First Name"}
                    value={name.first_name}
                    className={classes.textField}
                    required
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      changefirstname(namearr.indexOf(name), name.id, e.target.value)
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    label={"Last Name"}
                    value={name.last_name}
                    className={classes.textField}
                    required
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      changelastname(namearr.indexOf(name), name.id, e.target.value)
                    }
                   
                  />
                  </FormGroup>
                  <FormGroup row className={classes.formGroup}>
                  <TextField
                    variant="outlined"
                    type="date"
                    inputProps={{ max: fupfinalDate2}}
                    label={"Birth Date"}
                    value={name.birth_date}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      changebirthdate(namearr.indexOf(name), name.id, e.target.value)
                    }
                   
                  />
                    <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="gender">Gender</InputLabel>
                    <Select
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="gender"
                      required
                      variant="outlined"
                      value={name.gender}
                      onChange={(e) =>
                        changegender(namearr.indexOf(name), name.id, e.target.value)
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                      <MenuItem value={"Male"}>Male</MenuItem>
                      <MenuItem value={"Female"}>Female</MenuItem>
                     
                    </Select>
                  </FormControl>
                  <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="leadpax">Lead Pax?</InputLabel>
                    <Select
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="leadpax"
                      required
                      variant="outlined"
                      value={name.lead_pax}
                      onChange={(e) =>
                        changeleadpax(namearr.indexOf(name), name.id, e.target.value)
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                      <MenuItem value={"Yes"}>Yes</MenuItem>
                      <MenuItem value={"No"}>No</MenuItem>
                     
                    </Select>
                  </FormControl>
                  </FormGroup>
                  <FormGroup row className={classes.formGroup}>
                  <TextField
                    variant="outlined"
                    label={"Passport Number"}
                    value={name.passport_number}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      changepassportnumber(namearr.indexOf(name), name.id, e.target.value)
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    type="date"
                    label={"Passport Issue"}
                    value={name.passport_issue}
                    className={classes.textField}
                    inputProps={{ max: fupfinalDate2 }}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      changepassportissue(namearr.indexOf(name), name.id, e.target.value)
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    type="date"
                    disabled
                    label={"Passport Expiry"}
                    value={name.passport_expiry}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    // onChange={(e) =>
                    //   changepassportexpiry(namearr.indexOf(name), name.id, e.target.value)
                    // }
                   
                  />
                  </FormGroup>
                  <FormGroup row className={classes.formGroup}>
                  <TextField
                    variant="outlined"
                    label={"Passport Country"}
                    value={name.passport_country}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      changepassportcountry(namearr.indexOf(name), name.id, e.target.value)
                    }
                   
                  />
                  <TextField
                    variant="outlined"

                    label={"PAN Number"}
                    value={name.pan_number}
                    className={classes.textField}

                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      changepan(namearr.indexOf(name), name.id, e.target.value)
                    }
                   
                  />
                 
                  </FormGroup>
                  <FormGroup row className={classes.formGroup}>
                  {name.type!=="Infant" && farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsLCC && ssrResponse && "Baggage" in ssrResponse?(<div>
                    {ssrResponse.Baggage.map(b=><div>
                      <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="baggage">Baggage</InputLabel>
                    <Select
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="baggage"
                      variant="outlined"
                      value={name.baggage}
                      onChange={(e) =>
                        changebaggage(namearr.indexOf(name), name.id, e.target.value, ssrResponse.Baggage.indexOf(b))
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                        <MenuItem value={""}>Clear</MenuItem>
                     {b.map(bg=>
                      <div>
                      {bg.Description==2?(""):(
                        <MenuItem value={bg.Weight}>{bg.Weight}</MenuItem>
                      )}
                      </div>
                     )}
                     
                    </Select>
                  </FormControl>
                    </div>
                    )}
                  </div>):("")}
                  </FormGroup>
                  <FormGroup row className={classes.formGroup}>
                  {farequoteResponse && "Results" in farequoteResponse && farequoteResponse.Results.IsLCC && ssrResponse && "MealDynamic" in ssrResponse?(<div>
                    {ssrResponse.MealDynamic.map(m=><div>
                      <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="meal">Meal</InputLabel>
                    <Select
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="meal"
                      variant="outlined"
                      value={name.meal}
                      onChange={(e) =>
                        changemeal(namearr.indexOf(name), name.id, e.target.value, ssrResponse.MealDynamic.indexOf(m))
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                    <MenuItem value={""}>Clear</MenuItem>
                     {m.map(md=>
                     <MenuItem value={md.AirlineDescription}>{md.AirlineDescription}</MenuItem>
                     )}
                     
                    </Select>
                  </FormControl>
                    </div>
                    )}
                  </div>):("")}
                  </FormGroup>
                  <FormGroup row className={classes.formGroup}>
                  {farequoteResponse && "Results" in farequoteResponse && !farequoteResponse.Results.IsLCC && ssrResponse && "Meal" in ssrResponse?(<div>
                      <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="meal">Meal</InputLabel>
                    <Select
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="meal"
                      variant="outlined"
                      value={name.meal}
                      onChange={(e) =>
                        changemeals(namearr.indexOf(name), name.id, e.target.value)
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                        <MenuItem value={""}>Clear</MenuItem>
                     {ssrResponse.Meal.map(md=>
                     <MenuItem value={md.Description}>{md.Description}</MenuItem>
                     )}
                     
                    </Select>
                  </FormControl>
                    </div>
                  ):("")}
                  </FormGroup>
                  <FormGroup row className={classes.formGroup}>
                  {name.type!=="Infant" && farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsLCC && ssrResponse2 && "Baggage" in ssrResponse2?(<div>
                  <h4 className={classes.black}> Return Flight</h4>
                    {ssrResponse2.Baggage.map(b=><div>
                    
                      <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="baggage2">Baggage</InputLabel>
                    <Select
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="baggage2"
                      variant="outlined"
                      value={name.baggage2}
                      onChange={(e) =>
                        changebaggage2(namearr.indexOf(name), name.id, e.target.value, ssrResponse2.Baggage.indexOf(b))
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                        <MenuItem value={""}>Clear</MenuItem>
                     {b.map(bg=>
                     <div>
                      {bg.Description==2?(""):(
                        <MenuItem value={bg.Weight}>{bg.Weight}</MenuItem>
                      )}
                      </div>
                     )}
                     
                    </Select>
                  </FormControl>
                    </div>
                    )}
                  </div>):("")}
                  </FormGroup>
                  <FormGroup row className={classes.formGroup}>
                  {farequoteResponse2 && "Results" in farequoteResponse2 && farequoteResponse2.Results.IsLCC && ssrResponse2 && "MealDynamic" in ssrResponse2?(<div>
                    {ssrResponse2.MealDynamic.map(m=><div>
                      <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="meal2">Meal</InputLabel>
                    <Select
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="meal2"
                      variant="outlined"
                      value={name.meal2}
                      onChange={(e) =>
                        changemeal2(namearr.indexOf(name), name.id, e.target.value, ssrResponse2.MealDynamic.indexOf(m))
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                    <MenuItem value={""}>Clear</MenuItem>
                     {m.map(md=>
                     <MenuItem value={md.AirlineDescription}>{md.AirlineDescription}</MenuItem>
                     )}
                     
                    </Select>
                  </FormControl>
                    </div>
                    )}
                  </div>):("")}
                  </FormGroup>
                  <FormGroup row className={classes.formGroup}>
                  {farequoteResponse2 && "Results" in farequoteResponse2 && !farequoteResponse2.Results.IsLCC && ssrResponse2 && "Meal" in ssrResponse2?(<div>
                      <FormControl
                    style={{
                      minwidth: 320,
                      marginTop: 16,
                      marginRight: 32,
                      marginLeft: 32,
                    }}
                  >
                    <InputLabel id="meal3">Meal</InputLabel>
                    <Select
                      InputLabelProps={{ shrink: true }}
                      classname={classes.textField}
                      labelId="meal3"
                      variant="outlined"
                      value={name.meal2}
                      onChange={(e) =>
                        changemeals2(namearr.indexOf(name), name.id, e.target.value)
                      }
                      // onChange={e=>ratingchange(e)}
                    >
                        <MenuItem value={""}>Clear</MenuItem>
                     {ssrResponse2.Meal.map(md=>
                     <MenuItem value={md.Description}>{md.Description}</MenuItem>
                     )}
                     
                    </Select>
                  </FormControl>
                    </div>
                  ):("")}
                  </FormGroup>
                 
            <hr></hr>
          </div>
          )}
          <FormGroup row className={classes.formGroup}>
          <TextField
                    variant="outlined"
                    label={"Country Code"}
                    value={namearr.country_code}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, country_code:e.target.value})
                    }
                   
                  />
          <TextField
                    variant="outlined"
                    label={"Country"}
                    value={namearr.country}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, country:e.target.value})
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    label={"City"}
                    value={namearr.city}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, city:e.target.value})
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    label={"Address"}
                    value={namearr.address}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, address:e.target.value})
                    }
                   
                  />
          </FormGroup>
          <FormGroup row className={classes.formGroup}>
          <TextField
                    variant="outlined"
                    label={"Email"}
                    value={commonobj.email}
                    className={classes.textField}
                    required
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, email:e.target.value})
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    label={"Country Code"}
                    value={commonobj.cell_country_code}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    required
                    onChange={(e) =>
                      setcommonobj({...commonobj, cell_country_code:e.target.value})
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    label={"Contact Number"}
                    value={commonobj.contact_number}
                    required
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, contact_number:e.target.value})
                    }
                   
                  />
          </FormGroup>
          <hr></hr>
          <FormGroup row className={classes.formGroup}>
          <TextField
                    variant="outlined"
                    label={"GST Company"}
                    value={namearr.gst_company}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, gst_company:e.target.value})
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    label={"GST Number"}
                    value={namearr.gst_number}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, gst_number:e.target.value})
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    label={"GST Address"}
                    value={namearr.gst_address}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, gst_address:e.target.value})
                    }
                   
                  />
          </FormGroup>
          <FormGroup row className={classes.formGroup}>
          <TextField
                    variant="outlined"
                    label={"GST Email"}
                    value={namearr.gst_email}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, gst_email:e.target.value})
                    }
                   
                  />
                  <TextField
                    variant="outlined"
                    label={"GST Contact"}
                    value={namearr.gst_contact}
                    className={classes.textField}
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setcommonobj({...commonobj, gst_contact:e.target.value})
                    }
                   
                  />
          </FormGroup>
          <Typography className={classes.blue} variant="h4">Total Price: {(farequoteResponse && "Results" in farequoteResponse?getprice(farequoteResponse.Results.Fare)+getssrprice(namearr):0)+(farequoteResponse2 && "Results" in farequoteResponse2?getprice(farequoteResponse2.Results.Fare):0)}</Typography>
          <FormGroup row className={classes.formGroup}>
          <Button
                    variant="contained"
                    color="primary"
                    
                    type="submit"
                    className={classes.button}
                  >
                    Book
                  </Button>
          </FormGroup>
          </form>
          </Paper>
        </div>
       ):("")}
        </div>)}
        </div>)
}

export default TBOBook;